<template>
    <div>
        <div class="myarea-header">
            <span class="line"></span>
            <div class="container">
                <h1 class="myarea-heading"><span class="main-class" v-if="serviceName == 'Personal Accident'"> Personal Accident </span> <span class="main-class" v-else> {{serviceName}} Insurance </span> <span class="subclass"> {{ subClassName }} </span>
                </h1>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col">
                    <!-- {{ $route.params.alias }} -->
                    <div class="form-submitted" v-if="congratulations">
                        <div class="js-container con-container" style="top:0px !important;"></div>
                        <div>
                            <img src="../assets/images/superhero4.png" alt="" />
                            <h1>Congratulations!</h1>
                            <p>Your Insurance Request has been processed and submitted successfully. Our representative will get back to you shortly.</p>
                        </div>  
                    </div>
                    <div class="row mb-4">
                        <div class="col-md-12">
                            <ul class="tabs-switchers">
                                <li v-for="(step, index) in mainSteps" :class="{ active: isActive(step), done: isDone(index) }">
                                    <span class="icon-holder" v-if="step === 'personelDetail'">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5" d="M3 10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14V10Z" fill="#BEBEBE"/>
                                            <path d="M16.5189 16.5013C16.6939 16.3648 16.8526 16.2061 17.1701 15.8886L21.1275 11.9312C21.2231 11.8356 21.1793 11.6708 21.0515 11.6264C20.5844 11.4644 19.9767 11.1601 19.4083 10.5917C18.8399 10.0233 18.5356 9.41561 18.3736 8.94849C18.3292 8.82066 18.1644 8.77687 18.0688 8.87254L14.1114 12.8299C13.7939 13.1474 13.6352 13.3061 13.4987 13.4811C13.3377 13.6876 13.1996 13.9109 13.087 14.1473C12.9915 14.3476 12.9205 14.5606 12.7786 14.9865L12.5951 15.5368L12.3034 16.4118L12.0299 17.2323C11.9601 17.4419 12.0146 17.6729 12.1708 17.8292C12.3271 17.9854 12.5581 18.0399 12.7677 17.9701L13.5882 17.6966L14.4632 17.4049L15.0135 17.2214L15.0136 17.2214C15.4394 17.0795 15.6524 17.0085 15.8527 16.913C16.0891 16.8004 16.3124 16.6623 16.5189 16.5013Z" fill="#BEBEBE"/>
                                            <path d="M22.3665 10.6922C23.2112 9.84754 23.2112 8.47812 22.3665 7.63348C21.5219 6.78884 20.1525 6.78884 19.3078 7.63348L19.1806 7.76071C19.0578 7.88348 19.0022 8.05496 19.0329 8.22586C19.0522 8.33336 19.0879 8.49053 19.153 8.67807C19.2831 9.05314 19.5288 9.54549 19.9917 10.0083C20.4545 10.4712 20.9469 10.7169 21.3219 10.847C21.5095 10.9121 21.6666 10.9478 21.7741 10.9671C21.945 10.9978 22.1165 10.9422 22.2393 10.8194L22.3665 10.6922Z" fill="#BEBEBE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H14.5C14.9142 8.25 15.25 8.58579 15.25 9C15.25 9.41421 14.9142 9.75 14.5 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H11C11.4142 12.25 11.75 12.5858 11.75 13C11.75 13.4142 11.4142 13.75 11 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H9.5C9.91421 16.25 10.25 16.5858 10.25 17C10.25 17.4142 9.91421 17.75 9.5 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z" fill="#BEBEBE"/>
                                        </svg>

                                    </span>
                                    <span class="icon-holder" v-else-if="step === 'package'">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.62442 4.4489C9.50121 3.69796 10.6208 3.25 12 3.25C13.3792 3.25 14.4988 3.69796 16.3756 4.4489L19.3451 5.6367C20.2996 6.01851 21.0728 6.32776 21.6035 6.60601C21.8721 6.74683 22.1323 6.90648 22.333 7.09894C22.5392 7.29668 22.75 7.59658 22.75 8C22.75 8.40342 22.5392 8.70332 22.333 8.90106C22.1323 9.09352 21.8721 9.25317 21.6035 9.39399C21.0728 9.67223 20.2996 9.98148 19.3451 10.3633L16.3756 11.5511C14.4988 12.302 13.3792 12.75 12 12.75C10.6208 12.75 9.50121 12.302 7.62443 11.5511L4.65495 10.3633C3.70037 9.98149 2.9272 9.67223 2.39647 9.39399C2.12786 9.25317 1.86765 9.09352 1.66701 8.90106C1.46085 8.70332 1.25 8.40342 1.25 8C1.25 7.59658 1.46085 7.29668 1.66701 7.09894C1.86765 6.90648 2.12786 6.74683 2.39647 6.60601C2.92721 6.32776 3.70037 6.01851 4.65496 5.63669L7.62442 4.4489Z" fill="#BEBEBE"/>
                                            <path opacity="0.7" d="M2.50248 11.4432L2.49899 11.4402C2.19062 11.1654 1.71762 11.1915 1.44158 11.4992C1.16499 11.8075 1.19103 12.282 1.49936 12.5586C1.49936 12.5586 1.49905 12.5583 1.99987 12L1.49936 12.5586L1.50044 12.5595L1.5022 12.5611L1.50682 12.5652L1.52052 12.5772C1.53164 12.5868 1.54671 12.5997 1.56573 12.6155C1.60379 12.6473 1.65768 12.6911 1.72743 12.745C1.86692 12.8528 2.06992 13.001 2.33649 13.1739C2.86958 13.5196 3.65745 13.9644 4.70015 14.3814L7.50862 15.5048L7.62429 15.5511C9.50108 16.302 10.6206 16.75 11.9999 16.75C13.3791 16.75 14.4987 16.302 16.3754 15.5511L16.4911 15.5048L19.2996 14.3814C20.3423 13.9644 21.1302 13.5196 21.6632 13.1739C21.9298 13.001 22.1328 12.8528 22.2723 12.745C22.3421 12.6911 22.3959 12.6473 22.434 12.6155C22.453 12.5997 22.4681 12.5868 22.4792 12.5772L22.4929 12.5652L22.4975 12.5611L22.4993 12.5595L22.5007 12.5583C22.809 12.2817 22.8347 11.8075 22.5582 11.4992C22.2821 11.1915 21.8093 11.1652 21.501 11.44L21.4993 11.4415L21.4973 11.4432C21.4929 11.4471 21.4846 11.4541 21.4726 11.4641C21.4486 11.4842 21.4094 11.5161 21.3551 11.5581C21.2463 11.6422 21.077 11.7663 20.8471 11.9154C20.3872 12.2136 19.6857 12.6115 18.7425 12.9887L15.934 14.1121C13.9092 14.922 13.0603 15.25 11.9999 15.25C10.9395 15.25 10.0905 14.922 8.06571 14.1121L5.25724 12.9887C4.31406 12.6115 3.61251 12.2136 3.15267 11.9154C2.92276 11.7663 2.7534 11.6422 2.64465 11.5581C2.59029 11.5161 2.5511 11.4842 2.52709 11.4641C2.51509 11.4541 2.50689 11.4471 2.50248 11.4432Z" fill="#BEBEBE"/>
                                            <path opacity="0.4" d="M2.49883 15.4991C2.19045 15.2243 1.71762 15.2506 1.44158 15.5583C1.16499 15.8666 1.19103 16.3411 1.49936 16.6177L1.50044 16.6186L1.5022 16.6202L1.50682 16.6243L1.52052 16.6362C1.53164 16.6459 1.54671 16.6587 1.56573 16.6746C1.60379 16.7064 1.65768 16.7502 1.72743 16.8041C1.86692 16.9119 2.06992 17.0601 2.33649 17.233C2.86958 17.5787 3.65745 18.0234 4.70015 18.4405L7.50862 19.5639L7.62429 19.6102C9.50108 20.3611 10.6206 20.8091 11.9999 20.8091C13.3791 20.8091 14.4987 20.3611 16.3754 19.6102L16.4911 19.5639L19.2996 18.4405C20.3423 18.0234 21.1302 17.5787 21.6632 17.233C21.9298 17.0601 22.1328 16.9119 22.2723 16.8041C22.3421 16.7502 22.3959 16.7064 22.434 16.6746C22.453 16.6587 22.4681 16.6459 22.4792 16.6362L22.4929 16.6243L22.4975 16.6202L22.4993 16.6186L22.5007 16.6174C22.809 16.3408 22.8347 15.8666 22.5582 15.5583C22.2821 15.2506 21.8093 15.2243 21.501 15.4991L21.4993 15.5005L21.4973 15.5023C21.4929 15.5061 21.4846 15.5132 21.4726 15.5232C21.4486 15.5432 21.4094 15.5752 21.3551 15.6172C21.2463 15.7013 21.077 15.8254 20.8471 15.9745C20.3872 16.2727 19.6857 16.6705 18.7425 17.0478L15.934 18.1712C13.9092 18.9811 13.0603 19.3091 11.9999 19.3091C10.9395 19.3091 10.0905 18.9811 8.06571 18.1712L5.25724 17.0478C4.31406 16.6705 3.61251 16.2727 3.15267 15.9745C2.92276 15.8254 2.7534 15.7013 2.64465 15.6172C2.59029 15.5752 2.5511 15.5432 2.52709 15.5232C2.51509 15.5132 2.50689 15.5061 2.50248 15.5023L2.49883 15.4991Z" fill="#BEBEBE"/>
                                        </svg>
                                    </span>
                                    <span class="icon-holder" v-else-if="step === 'upload-info'">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5" d="M22 15.9998V14.9998C22 12.1714 21.9998 10.7576 21.1211 9.87891C20.2424 9.00023 18.8282 9.00023 15.9998 9.00023H7.99977C5.17135 9.00023 3.75713 9.00023 2.87845 9.87891C2 10.7574 2 12.1706 2 14.9976V14.9998V15.9998C2 18.8282 2 20.2424 2.87868 21.1211C3.75736 21.9998 5.17157 21.9998 8 21.9998H16H16C18.8284 21.9998 20.2426 21.9998 21.1213 21.1211C22 20.2424 22 18.8282 22 15.9998Z" fill="#BEBEBE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 4.02744L14.4306 5.98809C14.7001 6.30259 15.1736 6.33901 15.4881 6.06944C15.8026 5.79988 15.839 5.3264 15.5695 5.01191L12.5695 1.51191C12.427 1.34567 12.219 1.25 12 1.25C11.7811 1.25 11.5731 1.34567 11.4306 1.51191L8.43057 5.01191C8.161 5.3264 8.19743 5.79988 8.51192 6.06944C8.82641 6.33901 9.29989 6.30259 9.56946 5.98809L11.25 4.02744L11.25 15C11.25 15.4142 11.5858 15.75 12 15.75Z" fill="#BEBEBE"/>
                                        </svg>
                                    </span>
                                    <span class="icon-holder" v-else-if="step === 'summary'">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5" d="M22 15.9998V14.9998C22 12.1714 21.9998 10.7576 21.1211 9.87891C20.2424 9.00023 18.8282 9.00023 15.9998 9.00023H7.99977C5.17135 9.00023 3.75713 9.00023 2.87845 9.87891C2 10.7574 2 12.1706 2 14.9976V14.9998V15.9998C2 18.8282 2 20.2424 2.87868 21.1211C3.75736 21.9998 5.17157 21.9998 8 21.9998H16H16C18.8284 21.9998 20.2426 21.9998 21.1213 21.1211C22 20.2424 22 18.8282 22 15.9998Z" fill="#BEBEBE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 4.02744L14.4306 5.98809C14.7001 6.30259 15.1736 6.33901 15.4881 6.06944C15.8026 5.79988 15.839 5.3264 15.5695 5.01191L12.5695 1.51191C12.427 1.34567 12.219 1.25 12 1.25C11.7811 1.25 11.5731 1.34567 11.4306 1.51191L8.43057 5.01191C8.161 5.3264 8.19743 5.79988 8.51192 6.06944C8.82641 6.33901 9.29989 6.30259 9.56946 5.98809L11.25 4.02744L11.25 15C11.25 15.4142 11.5858 15.75 12 15.75Z" fill="#BEBEBE"/>
                                        </svg>
                                    </span>
                                    <span class="icon-holder" v-else>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1096 13.4999C12.4704 12.9551 11.5302 12.9551 10.891 13.4999C10.617 13.7333 10.2764 13.8744 9.91767 13.903C9.08046 13.9698 8.41564 14.6347 8.34883 15.4719C8.3202 15.8306 8.17912 16.1712 7.94568 16.4452C7.40092 17.0844 7.40092 18.0246 7.94568 18.6638C8.17912 18.9378 8.3202 19.2784 8.34883 19.6371C8.41564 20.4744 9.08046 21.1392 9.91767 21.206C10.2764 21.2346 10.617 21.3757 10.891 21.6091C11.5302 22.1539 12.4704 22.1539 13.1096 21.6091C13.3836 21.3757 13.7242 21.2346 14.0829 21.206C14.9202 21.1392 15.585 20.4744 15.6518 19.6371C15.6804 19.2784 15.8215 18.9378 16.0549 18.6638C16.5997 18.0246 16.5997 17.0844 16.0549 16.4452C15.8215 16.1712 15.6804 15.8306 15.6518 15.4719C15.585 14.6347 14.9202 13.9698 14.0829 13.903C13.7242 13.8744 13.3836 13.7333 13.1096 13.4999ZM14.0122 17.103C14.315 16.8204 14.3314 16.3458 14.0488 16.043C13.7662 15.7401 13.2916 15.7238 12.9888 16.0064L11.3576 17.5288L11.0122 17.2064C10.7094 16.9238 10.2348 16.9401 9.9522 17.243C9.66957 17.5458 9.68594 18.0204 9.98875 18.303L10.8459 19.103C11.1341 19.3719 11.5812 19.3719 11.8694 19.103L14.0122 17.103Z" fill="#BEBEBE"/>
                                            <path opacity="0.5" d="M2 12V8C2 5.17157 2 3.75736 2.87868 2.87868C3.75736 2 5.17157 2 8 2H16C18.8284 2 20.2426 2 21.1213 2.87868C22 3.75736 22 5.17157 22 8V12C22 14.8284 22 16.2426 21.1213 17.1213C20.2855 17.9571 18.9652 17.9979 16.4042 17.9999C16.5467 17.4702 16.4302 16.8862 16.0544 16.4453C15.821 16.1714 15.6799 15.8308 15.6513 15.472C15.5845 14.6348 14.9197 13.97 14.0824 13.9031C13.7237 13.8745 13.3831 13.7334 13.1092 13.5C12.4699 12.9552 11.5297 12.9552 10.8905 13.5C10.6165 13.7334 10.276 13.8745 9.91719 13.9031C9.07997 13.97 8.41515 14.6348 8.34834 15.472C8.31971 15.8308 8.17863 16.1714 7.94519 16.4453C7.56948 16.8862 7.4529 17.4702 7.59543 17.9999C5.03465 17.9979 3.71443 17.9571 2.87868 17.1213C2 16.2426 2 14.8284 2 12Z" fill="#BEBEBE"/>
                                            <path d="M8.25 6C8.25 5.58579 8.58579 5.25 9 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6Z" fill="#BEBEBE"/>
                                            <path d="M7 8.75C6.58579 8.75 6.25 9.08579 6.25 9.5C6.25 9.91421 6.58579 10.25 7 10.25H17C17.4142 10.25 17.75 9.91421 17.75 9.5C17.75 9.08579 17.4142 8.75 17 8.75H7Z" fill="#BEBEBE"/>
                                        </svg>

                                    </span>
                                    <span v-if="step === 'personelDetail'" class="text-box">Personel Details</span>
                                    <span v-else-if="step === 'package'" class="text-box">Choose Package</span>
                                    <span v-else-if="step === 'upload-info'" class="text-box">Upload Information & Documents</span>
                                    <span v-else-if="step === 'summary'" class="text-box">Summary</span>
                                    <span v-else-if="step === 'payment'" class="text-box">Make Payment</span>
                                    <span v-else class="text-box">{{ step }}</span>
                                    
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="!congratulations" class="feature-form-main">

                        <div class="row" v-if="!IsDisablebTabs && subClassInnerCategories.length > 1">
                            <div class="col-md-12">
                               

                                <div class="col mt-4 clearfix">
                                    <ul class="subclass-selecters">
                                        <li v-for="(value,index) in subClassInnerCategories">
                                            <span class="subclassBtn" :class="{'active': activeSubclassIndex === index}" @click="selectSubClass(index); getSingleId(value)"> {{ value.name }} </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <div class="tab-content" id="v-pills-tabContent">
                                    <div class="loader" v-if="loader"></div>
                                    <div class="tab-pane fade" :class="{ 'active show': isActive('personelDetail') }" id="personelDetail">
                                        <div class="container">
                                            <div class="row get-product-form">
                                                <div v-for="(value,key) in subClassForm" :key="key" class="col-md-6 mb-3" >
                                                    <label class="label block-label" :for="value.field_name"> {{value.label}} <em> * </em></label>
                                                    <select :id="value.field_name" v-if="value.type == 'dropDown' && value.field_name !== 'departre_airport'"  
                                                        @change="changeChild(value.child_id,$event)"  class="form-control"
                                                        :required="value.required == 1 ? true : false"
                                                    >
                                                        <option selected>--- Select --- </option>
                                                        <option :value="options.id" :data-id="options.form_field_id" v-for="(options , jKey) in value.defaultvaluesparent"> {{options.text}}</option>
                                                    </select>
                                                    <select :id="value.field_name" v-else-if="value.type == 'dropDown' && value.field_name == 'departre_airport'"  
                                                        @change="changeChild(value.child_id,$event)"  class="form-control"
                                                        :required="value.required == 1 ? true : false"
                                                    >
                                                        <option> --- Select --- </option>
                                                        <option value="5354">Islamabad (ISB)</option>
                                                        <option value="5355">Karachi (KHI)</option>
                                                        <option value="5356">Lahore (LHE)</option>
                                                        <option value="5360">Multan (MUX)</option>
                                                        <option value="5361">Peshawar (PEW)</option>
                                                        <template v-for="(options , jKey) in value.default_values">
                                                            <option :value="options.id" :data-id="options.form_fields_id" v-if="options.text !== 'Islamabad (ISB)' && options.text !== 'Karachi (KHI)' && options.text !== 'Lahore (LHE)' && options.text !== 'Multan (MUX)' && options.text !== 'Peshawar (PEW)'">
                                                                {{options.text}}
                                                            </option>
                                                        </template>
                                                    </select>
                                                    <Datepicker
                                                        v-else-if="value.type === 'date' && (value.field_name === 'date_of_birth' || value.field_name === 'date_of_birtth')"
                                                        ref="datepickers"
                                                        class="form-control"
                                                        :placeholder="value.label"
                                                        :id="value.field_name"
                                                        @update:modelValue="setFormFieldValuesObject('datepicker', value, $event)"
                                                        :upper-limit="maxDate"
                                                        :value="formSelectedFieldsValues[value.field_name]"
                                                        @input="updateSelectedDate($event.target.value, value.field_name)"
                                                        :clearable="true"
                                                        inputFormat="yy-dd-mm"
                                                    />
                                                    <Datepicker
                                                        v-else-if="value.type === 'date' && (value.field_name === 'spouse_age')"
                                                        ref="datepickers"
                                                        class="form-control"
                                                        :placeholder="value.label"
                                                        :id="value.field_name"  
                                                        @update:modelValue="setFormFieldValuesObject('datepicker', value, $event)"
                                                        :upper-limit="maxDate"
                                                        :value="formSelectedFieldsValues[value.field_name]"
                                                        @input="updateSelectedDate($event.target.value, value.field_name)"
                                                        :clearable="true"
                                                    />
                                                    <Datepicker
                                                        v-else-if="value.type === 'date'"
                                                        ref="datepickers"
                                                        class="form-control"
                                                        :placeholder="value.label"
                                                        :id="value.field_name"  
                                                        :clearable="true"
                                                        @update:modelValue="setFormFieldValuesObject('datepicker', value, $event)"
                                                        :lower-limit="new Date()"
                                                        :value="formSelectedFieldsValues[value.field_name]"
                                                        @input="updateSelectedDate($event.target.value, value.field_name)"
                                                    />
                                                    <div v-else-if="value.type == 'radioButton'">
                                                        <!-- <label class="label">{{ value.label }}</label> -->
                                                        <div class="form-group m-0">
                                                            <label class="radio-holder" v-for="option in value.defaultvaluesparent" :for="option.text" :key="option.field_id">
                                                                <input type="radio" :id="option.text" :name="value.field_name" :value="option.text" @change="setFormRadio($event)" >
                                                                <span class="checkmark"></span>
                                                                {{ option.text }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <input v-else-if="value.field_name == 'vehicle_value'" :id="value.field_name" @keyup="setFormFieldValuesObject($event)" :type="value.inputType" placeholder="Type here" class="form-control" />
                                                    <input :id="value.field_name" @keyup="setFormFieldValuesObject($event)" v-else :type="value.inputType" placeholder="Type here" class="form-control" />
                                                    <span class="text-danger d-block" v-if="value.field_name == 'vehicle_value'">{{ words }}</span>
                                                    <span class="text-danger" v-if="validations[value.field_name]">{{validations[value.field_name][0]}}</span>
                                                    <span class="text-danger" v-if="validations[value.field_name+'.0']">{{validations[value.field_name+'.0'][0]}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col align-right">
                                                    <button type="submit" @click.prevent="getProductPlanList(0)" class="btn btn-primary arrow-btn"> 
                                                        Next 
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                        </svg>

                                                    </button>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                    <div class="tab-pane fade" :class="{ 'active show': isActive('package') }" id="package">
                                        <div  class="plan-filters">
                                            <div class="row">
                                                <div class="col">
                                                    <label> Filter by Company </label>
                                                    <select @change="getFilteredCompany($event)" v-model="filteredCompany" class="form-control">
                                                        <option selected value=""> Select company </option>
                                                        <option v-for="(value, index) in filteredCompanies" :key="index" :value="value.id"> {{ value.name }} </option>
                                                    </select>
                                                </div>
                                                <div class="col">
                                                    <label> Sort by Price </label>
                                                    <select @change="getFilteredByPrice($event)" v-model="sortPrice" class="form-control">
                                                        <option selected value=""> Select Price </option>
                                                        <option value="ASC"> High to Low </option>
                                                        <option value="DESC"> Low to High </option>
                                                    </select>
                                                </div>
                                                <div class="col">
                                                    <label> Sort by Date Created </label>
                                                    <select @change="getFilteredByDate($event)" v-model="sortByDate" class="form-control">
                                                        <option selected value="" > Select date created </option>
                                                        <option value="ASC"> newest to oldest </option>
                                                        <option value="DESC"> oldest to newest </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pakages-main" v-if="!showDetailsBox">
                                            <div v-for="(value,key) in productPlans" :key="key" class="package-box" @click="showDetails(value)">
                                                <div class="package-detail-box clearfix">
                                                    <div class="cart-head">
                                                        <span class="package-logo"><img :src="value.company_logo" :alt="value.company_name" /> </span>
                                                        <strong class="title"> {{ value.product_name }} </strong>
                                                    </div>
                                                    <div class="package-sum">
                                                        <ul>
                                                            <li>
                                                                <span class="sum-title"> Quote Validity </span>
                                                                <span class="sum-value"> {{ value.validity }} </span>
                                                            </li>
                                                            <li>
                                                                <span v-if="value.add_ons" class="sum-title"> Cover Limit </span>
                                                                <span v-if="value.add_ons" class="sum-value"> {{ value?.currency_symbol}}. {{ parseFloat(value?.sum_insured_value || 0).toLocaleString('en-US') }} </span>
                                                            </li>
                                                            <!-- <li>
                                                                <span class="stat-title"> Cover Limit </span>
                                                                <span class="stat-number">  {{ currentSelectedPlan.covers[0]?.currency_code }}  {{ (currentSelectedPlan?.sum_insured_value).toLocaleString('en-US') }} </span>
                                                            </li> -->
                                                            
                                                        </ul>
                                                    </div>
                                                    <div v-if="serviceName != 'Health' && serviceName != 'Travel'" class="rate">
                                                        <span class="sum-title"> Rate </span>
                                                        <span class="sum-value"> {{ value?.net_premium_rate }} % </span>
                                                    </div>
                                                    <span class="package-grand"> <span class="premimum"> Premimum Amount {{ value.currency_symbol}}. </span> <strong> {{ parseFloat(value?.price || 0).toLocaleString('en-US') }} </strong> </span>
                                                    <button class="btn btn-primary"> Buy Now </button>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="empty-reponse" v-show="productPlans.length === 0">
                                            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M7.493 0.015 C 7.442 0.021,7.268 0.039,7.107 0.055 C 5.234 0.242,3.347 1.208,2.071 2.634 C 0.660 4.211,-0.057 6.168,0.009 8.253 C 0.124 11.854,2.599 14.903,6.110 15.771 C 8.169 16.280,10.433 15.917,12.227 14.791 C 14.017 13.666,15.270 11.933,15.771 9.887 C 15.943 9.186,15.983 8.829,15.983 8.000 C 15.983 7.171,15.943 6.814,15.771 6.113 C 14.979 2.878,12.315 0.498,9.000 0.064 C 8.716 0.027,7.683 -0.006,7.493 0.015 M8.853 1.563 C 9.967 1.707,11.010 2.136,11.944 2.834 C 12.273 3.080,12.920 3.727,13.166 4.056 C 13.727 4.807,14.142 5.690,14.330 6.535 C 14.544 7.500,14.544 8.500,14.330 9.465 C 13.916 11.326,12.605 12.978,10.867 13.828 C 10.239 14.135,9.591 14.336,8.880 14.444 C 8.456 14.509,7.544 14.509,7.120 14.444 C 5.172 14.148,3.528 13.085,2.493 11.451 C 2.279 11.114,1.999 10.526,1.859 10.119 C 1.618 9.422,1.514 8.781,1.514 8.000 C 1.514 6.961,1.715 6.075,2.160 5.160 C 2.500 4.462,2.846 3.980,3.413 3.413 C 3.980 2.846,4.462 2.500,5.160 2.160 C 6.313 1.599,7.567 1.397,8.853 1.563 M7.706 4.290 C 7.482 4.363,7.355 4.491,7.293 4.705 C 7.257 4.827,7.253 5.106,7.259 6.816 C 7.267 8.786,7.267 8.787,7.325 8.896 C 7.398 9.033,7.538 9.157,7.671 9.204 C 7.803 9.250,8.197 9.250,8.329 9.204 C 8.462 9.157,8.602 9.033,8.675 8.896 C 8.733 8.787,8.733 8.786,8.741 6.816 C 8.749 4.664,8.749 4.662,8.596 4.481 C 8.472 4.333,8.339 4.284,8.040 4.276 C 7.893 4.272,7.743 4.278,7.706 4.290 M7.786 10.530 C 7.597 10.592,7.410 10.753,7.319 10.932 C 7.249 11.072,7.237 11.325,7.294 11.495 C 7.388 11.780,7.697 12.000,8.000 12.000 C 8.303 12.000,8.612 11.780,8.706 11.495 C 8.763 11.325,8.751 11.072,8.681 10.932 C 8.616 10.804,8.460 10.646,8.333 10.580 C 8.217 10.520,7.904 10.491,7.786 10.530 " stroke="none" fill-rule="evenodd" fill="#007FFF"></path></g></svg>
                                            <h2> There is no plan available! </h2>
                                        </div>
                                        <div class="package-detail-section" v-if="showDetailsBox">
                                            <div class="selected-package">
                                                <div class="package-detail-box clearfix">
                                                    <div class="package-detail-col">
                                                        <span class="package-logo"> <img :src="currentSelectedPlan.company_logo" :alt="currentSelectedPlan.company_name" /> </span>
                                                    </div>
                                                    <div class="package-detail-col">
                                                        <strong class="title"> {{currentSelectedPlan.company_name}} </strong>
                                                        <span v-if="currentSelectedPlan?.plan_name" class="title-dot"> {{ currentSelectedPlan?.plan_name }} </span>
                                                        <span v-else class="title-dot"> {{ currentSelectedPlan?.product_name }} </span>
                                                    </div>
                                                    <div class="package-detail-col total">
                                                        <span class="total-head"> Total </span>
                                                        <span class="total-head-grand"> {{ currentSelectedPlan?.currency_symbol}}.  {{ parseFloat(currentSelectedPlan?.price).toLocaleString('en-US') }} </span>
                                                    </div>
                                                    <div class="package-detail-col">
                                                        <span class="stat-title"> Premium Amount </span>
                                                        <span class="stat-number">  {{ currentSelectedPlan?.currency_symbol}}.  {{ parseFloat(currentSelectedPlan?.price).toLocaleString('en-US') }} </span>
                                                    </div>
                                                    <div class="package-detail-col">
                                                        <span class="stat-title"> Cover Limit </span>
                                                        <span class="stat-number">  {{ currentSelectedPlan?.currency_symbol}}. {{ parseFloat(currentSelectedPlan?.sum_insured_value).toLocaleString('en-US') }} </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <h2> Plan Details </h2>
                                                    <ul class="package-detail-extra-info">
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.product_description && (currentSelectedPlan?.product_description !== '' || currentSelectedPlan?.product_description !== null)">
                                                            <div class="package-info-box" @click="packageExtraInfo('ProductDetail')">
                                                                <span class="icon-holder">
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M8.56035 20.576C10.3003 21.4891 11.1703 21.9456 12.1062 21.9456V12.0348L2.82764 7.15137C2.81398 7.17332 2.80056 7.19549 2.78738 7.21787C2.19531 8.22333 2.19531 9.4745 2.19531 11.9768V12.0928C2.19531 14.5951 2.19531 15.8463 2.78738 16.8517C3.37945 17.8572 4.4457 18.4167 6.57818 19.5358L8.56035 20.576Z" fill="#1C274C"/>
                                                                        <path opacity="0.7" d="M17.6366 4.53386L15.6544 3.49367C13.9144 2.58057 13.0445 2.12402 12.1086 2.12402C11.1727 2.12402 10.3028 2.58057 8.56279 3.49367L6.58062 4.53386C4.49561 5.62803 3.4299 6.18729 2.83008 7.15144L12.1086 12.0349L21.3871 7.15144C20.7873 6.18729 19.7216 5.62803 17.6366 4.53386Z" fill="#2F73FE"/>
                                                                        <path d="M21.4262 7.21787C21.413 7.19549 21.3996 7.17332 21.3859 7.15137L12.1074 12.0348V21.9456C13.0433 21.9456 13.9133 21.4891 15.6532 20.576L17.6354 19.5358C19.7679 18.4167 20.8341 17.8572 21.4262 16.8517C22.0183 15.8463 22.0183 14.5951 22.0183 12.0928V11.9768C22.0183 9.4745 22.0183 8.22333 21.4262 7.21787Z" fill="#2F73FE"/>
                                                                        <path d="M21.4262 7.21787C21.413 7.19549 21.3996 7.17332 21.3859 7.15137L12.1074 12.0348V21.9456C13.0433 21.9456 13.9133 21.4891 15.6532 20.576L17.6354 19.5358C19.7679 18.4167 20.8341 17.8572 21.4262 16.8517C22.0183 15.8463 22.0183 14.5951 22.0183 12.0928V11.9768C22.0183 9.4745 22.0183 8.22333 21.4262 7.21787Z" fill="url(#paint0_linear_3110_7647)"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7647" x1="14.5929" y1="14.5485" x2="21.7223" y2="14.5897" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Product Details </span>
                                                            </div>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.things_to_note && (currentSelectedPlan?.things_to_note !== '' || currentSelectedPlan?.things_to_note !== null)">
                                                            <div class="package-info-box" @click="packageExtraInfo('TermsConditions')">
                                                                <span class="icon-holder">
                                                                    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M3.52734 8.79189C3.52734 5.56715 3.52734 3.95477 4.52914 2.95297C5.53095 1.95117 7.14332 1.95117 10.3681 1.95117H12.0782C15.303 1.95117 16.9154 1.95117 17.9172 2.95297C18.919 3.95477 18.919 5.56715 18.919 8.79189V12.2123C18.919 15.437 18.919 17.0494 17.9172 18.0512C16.9154 19.053 15.303 19.053 12.0782 19.053H10.3681C7.14332 19.053 5.53095 19.053 4.52914 18.0512C3.52734 17.0494 3.52734 15.437 3.52734 12.2123V8.79189Z" fill="#2F73FE"/>
                                                                        <path d="M3.52734 8.79189C3.52734 5.56715 3.52734 3.95477 4.52914 2.95297C5.53095 1.95117 7.14332 1.95117 10.3681 1.95117H12.0782C15.303 1.95117 16.9154 1.95117 17.9172 2.95297C18.919 3.95477 18.919 5.56715 18.919 8.79189V12.2123C18.919 15.437 18.919 17.0494 17.9172 18.0512C16.9154 19.053 15.303 19.053 12.0782 19.053H10.3681C7.14332 19.053 5.53095 19.053 4.52914 18.0512C3.52734 17.0494 3.52734 15.437 3.52734 12.2123V8.79189Z" fill="url(#paint0_linear_3110_7636)"/>
                                                                        <path d="M15.0887 14.3515C15.2383 14.2348 15.374 14.0991 15.6455 13.8276L19.0294 10.4437C19.1112 10.3619 19.0738 10.221 18.9645 10.1831C18.565 10.0445 18.0454 9.78431 17.5594 9.29826C17.0733 8.81222 16.8132 8.29262 16.6746 7.89318C16.6367 7.78388 16.4958 7.74643 16.4139 7.82825L13.03 11.2122C12.7586 11.4836 12.6228 11.6193 12.5061 11.769C12.3684 11.9455 12.2504 12.1365 12.1541 12.3386C12.0724 12.5099 12.0117 12.692 11.8903 13.0562L11.7335 13.5268L11.4841 14.275L11.2502 14.9766C11.1905 15.1558 11.2371 15.3534 11.3707 15.487C11.5043 15.6205 11.7019 15.6672 11.8811 15.6074L12.5827 15.3736L13.3309 15.1242L13.8015 14.9673C14.1656 14.8459 14.3477 14.7852 14.519 14.7036C14.7211 14.6073 14.9121 14.4892 15.0887 14.3515Z" fill="#1C274C"/>
                                                                        <path d="M20.0889 9.3842C20.8112 8.66196 20.8112 7.49097 20.0889 6.76873C19.3667 6.04649 18.1957 6.04649 17.4735 6.76873L17.3647 6.87752C17.2597 6.9825 17.2121 7.12914 17.2383 7.27527C17.2548 7.36719 17.2854 7.50159 17.3411 7.66196C17.4523 7.98267 17.6625 8.40367 18.0582 8.79943C18.454 9.1952 18.875 9.40532 19.1957 9.51659C19.3561 9.57223 19.4905 9.60281 19.5824 9.61931C19.7285 9.64554 19.8751 9.59797 19.9801 9.49299L20.0889 9.3842Z" fill="#1C274C"/>
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.16211 7.93673C7.16211 7.58254 7.44924 7.29541 7.80343 7.29541H13.3615C13.7157 7.29541 14.0028 7.58254 14.0028 7.93673C14.0028 8.29092 13.7157 8.57805 13.3615 8.57805H7.80343C7.44924 8.57805 7.16211 8.29092 7.16211 7.93673ZM7.16211 11.3571C7.16211 11.0029 7.44924 10.7158 7.80343 10.7158H10.3687C10.7229 10.7158 11.01 11.0029 11.01 11.3571C11.01 11.7113 10.7229 11.9984 10.3687 11.9984H7.80343C7.44924 11.9984 7.16211 11.7113 7.16211 11.3571ZM7.16211 14.7775C7.16211 14.4233 7.44924 14.1361 7.80343 14.1361H9.08606C9.44025 14.1361 9.72738 14.4233 9.72738 14.7775C9.72738 15.1316 9.44025 15.4188 9.08606 15.4188H7.80343C7.44924 15.4188 7.16211 15.1316 7.16211 14.7775Z" fill="#2F73FE"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7636" x1="7.38731" y1="10.5021" x2="18.459" y2="10.588" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Term & Conditions </span>
                                                            </div>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.why_buy && (currentSelectedPlan?.why_buy !== '' || currentSelectedPlan?.why_buy !== null)">
                                                            <div class="package-info-box" @click="packageExtraInfo('WhyBuy')">
                                                                <span class="icon-holder">
                                                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.88938 5.80801C2.28764 5.70845 2.69122 5.95059 2.79078 6.34885L3.16934 7.8631C3.77372 10.2806 5.67827 12.155 8.09994 12.7234H15.9448C18.0172 12.7234 19.7616 14.2746 20.0037 16.3328L20.6474 21.8041C20.6954 22.2118 20.4037 22.5812 19.996 22.6292C19.5883 22.6771 19.2189 22.3855 19.171 21.9778L18.5273 16.5065C18.3732 15.1969 17.2634 14.21 15.9448 14.21H7.93457L7.85492 14.1923C4.84677 13.5239 2.47448 11.2132 1.7271 8.22366L1.34854 6.70941C1.24898 6.31115 1.49112 5.90758 1.88938 5.80801Z" fill="#1C274C"/>
                                                                        <path d="M8.01562 14.21V18.4221C8.01562 20.2909 8.01562 21.2253 8.59619 21.8058C9.17675 22.3864 10.1112 22.3864 11.98 22.3864C13.8488 22.3864 14.7832 22.3864 15.3637 21.8058C15.9443 21.2253 15.9443 20.2909 15.9443 18.4221V14.21H8.01562Z" fill="#2F73FE"/>
                                                                        <path d="M8.01562 14.21V18.4221C8.01562 20.2909 8.01562 21.2253 8.59619 21.8058C9.17675 22.3864 10.1112 22.3864 11.98 22.3864C13.8488 22.3864 14.7832 22.3864 15.3637 21.8058C15.9443 21.2253 15.9443 20.2909 15.9443 18.4221V14.21H8.01562Z" fill="url(#paint0_linear_3110_7644)"/>
                                                                        <circle cx="11.98" cy="6.52928" r="3.96434" fill="#1C274C"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7644" x1="10.004" y1="18.2982" x2="15.7073" y2="18.3459" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Why Buy </span>
                                                            </div>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.covers && (currentSelectedPlan?.covers !== '' || currentSelectedPlan?.covers !== null)">
                                                            <div class="package-info-box" @click="packageExtraInfo('Coverages')">
                                                                <span class="icon-holder">
                                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M3.98352 5.42993C3.60938 5.963 3.60938 7.54754 3.60938 10.7166V12.2773C3.60938 17.8651 7.81054 20.5767 10.4464 21.7282C11.1615 22.0405 11.519 22.1967 12.5291 22.1967C13.5393 22.1967 13.8968 22.0405 14.6118 21.7282C17.2477 20.5768 21.4489 17.8651 21.4489 12.2773V10.7166C21.4489 7.54754 21.4489 5.963 21.0747 5.42993C20.7006 4.89685 19.2107 4.38686 16.2309 3.36687L15.6632 3.17254C14.1099 2.64085 13.3333 2.375 12.5291 2.375C11.725 2.375 10.9483 2.64085 9.39505 3.17254L8.82735 3.36687C5.84757 4.38686 4.35767 4.89685 3.98352 5.42993Z" fill="#2F73FE"/>
                                                                        <path d="M3.98352 5.42993C3.60938 5.963 3.60938 7.54754 3.60938 10.7166V12.2773C3.60938 17.8651 7.81054 20.5767 10.4464 21.7282C11.1615 22.0405 11.519 22.1967 12.5291 22.1967C13.5393 22.1967 13.8968 22.0405 14.6118 21.7282C17.2477 20.5768 21.4489 17.8651 21.4489 12.2773V10.7166C21.4489 7.54754 21.4489 5.963 21.0747 5.42993C20.7006 4.89685 19.2107 4.38686 16.2309 3.36687L15.6632 3.17254C14.1099 2.64085 13.3333 2.375 12.5291 2.375C11.725 2.375 10.9483 2.64085 9.39505 3.17254L8.82735 3.36687C5.84757 4.38686 4.35767 4.89685 3.98352 5.42993Z" fill="url(#paint0_linear_3110_7651)"/>
                                                                        <path d="M15.5618 10.7984C15.8352 10.4922 15.8086 10.0223 15.5024 9.74891C15.1962 9.4755 14.7263 9.5021 14.4529 9.80832L11.4678 13.1517L10.6064 12.1869C10.333 11.8807 9.86308 11.8541 9.55686 12.1275C9.25063 12.4009 9.22404 12.8708 9.49745 13.177L10.9133 14.7628C11.0543 14.9207 11.256 15.011 11.4678 15.011C11.6795 15.011 11.8812 14.9207 12.0222 14.7628L15.5618 10.7984Z" fill="#1C274C"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7651" x1="8.08324" y1="12.2858" x2="20.9158" y2="12.3854" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Coverages </span>
                                                            </div>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.exclusions && (currentSelectedPlan?.exclusions !== '' || currentSelectedPlan?.exclusions !== null)">
                                                            <div class="package-info-box" @click="packageExtraInfo('Exclusions')">
                                                                <span class="icon-holder">
                                                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M4.26904 17.3078L5.68076 18.7195L7.09275 20.1313C7.95211 20.9907 8.38179 21.4204 8.92819 21.6467C9.47458 21.873 10.0822 21.873 11.2976 21.873H13.5792C14.7945 21.873 15.4022 21.873 15.9486 21.6467C16.495 21.4204 16.9247 20.9907 17.784 20.1313L20.6075 17.3078C21.4669 16.4485 21.8966 16.0188 22.1229 15.4724C22.3492 14.926 22.3492 14.3183 22.3492 13.103V10.8214C22.3492 9.60606 22.3492 8.9984 22.1229 8.452C21.8966 7.9056 21.4669 7.47592 20.6075 6.61656L19.1957 5.2048L17.7838 3.79296C16.9245 2.9336 16.4948 2.50392 15.9484 2.27759C15.402 2.05127 14.7943 2.05127 13.579 2.05127H11.2974C10.0821 2.05127 9.47439 2.05127 8.92799 2.2776C8.3816 2.50392 7.95191 2.9336 7.09255 3.79296L4.26904 6.61648C3.40967 7.47584 2.97999 7.90552 2.75367 8.45192C2.52734 8.99832 2.52734 9.60598 2.52734 10.8213V13.1029C2.52734 14.3183 2.52734 14.9259 2.75367 15.4723C2.97999 16.0187 3.40968 16.4484 4.26904 17.3078Z" fill="#2F73FE"/>
                                                                        <path d="M4.26904 17.3078L5.68076 18.7195L7.09275 20.1313C7.95211 20.9907 8.38179 21.4204 8.92819 21.6467C9.47458 21.873 10.0822 21.873 11.2976 21.873H13.5792C14.7945 21.873 15.4022 21.873 15.9486 21.6467C16.495 21.4204 16.9247 20.9907 17.784 20.1313L20.6075 17.3078C21.4669 16.4485 21.8966 16.0188 22.1229 15.4724C22.3492 14.926 22.3492 14.3183 22.3492 13.103V10.8214C22.3492 9.60606 22.3492 8.9984 22.1229 8.452C21.8966 7.9056 21.4669 7.47592 20.6075 6.61656L19.1957 5.2048L17.7838 3.79296C16.9245 2.9336 16.4948 2.50392 15.9484 2.27759C15.402 2.05127 14.7943 2.05127 13.579 2.05127H11.2974C10.0821 2.05127 9.47439 2.05127 8.92799 2.2776C8.3816 2.50392 7.95191 2.9336 7.09255 3.79296L4.26904 6.61648C3.40967 7.47584 2.97999 7.90552 2.75367 8.45192C2.52734 8.99832 2.52734 9.60598 2.52734 10.8213V13.1029C2.52734 14.3183 2.52734 14.9259 2.75367 15.4723C2.97999 16.0187 3.40968 16.4484 4.26904 17.3078Z" fill="url(#paint0_linear_3110_7640)"/>
                                                                        <path d="M19.1985 5.20508L5.68359 18.7198" stroke="#1C274C" stroke-width="1.1893"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7640" x1="7.49835" y1="11.9622" x2="21.7567" y2="12.0851" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Exlusions </span>
                                                            </div>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.brochure && (currentSelectedPlan?.brochure !== '' || currentSelectedPlan?.brochure !== null)">
                                                            <a class="package-info-box" :href="currentSelectedPlan?.brochure">
                                                                <span class="icon-holder">
                                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9.99561 13.1603C9.99561 11.9288 10.994 10.9304 12.2256 10.9304C13.4571 10.9304 14.4555 11.9288 14.4555 13.1603C14.4555 14.3919 13.4571 15.3903 12.2256 15.3903C10.994 15.3903 9.99561 14.3919 9.99561 13.1603Z" fill="#1C274C"/>
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29688 18.8039V4.92871C4.29688 5.47607 4.7406 5.9198 5.28796 5.9198H17.181C18.8231 5.9198 20.1542 7.25097 20.1542 8.89305V18.8039C20.1542 20.446 18.8231 21.7771 17.181 21.7771H7.27013C5.62805 21.7771 4.29688 20.446 4.29688 18.8039ZM8.50898 13.1603C8.50898 11.1077 10.1729 9.44376 12.2256 9.44376C14.2782 9.44376 15.9421 11.1077 15.9421 13.1603C15.9421 15.2129 14.2782 16.8769 12.2256 16.8769C10.1729 16.8769 8.50898 15.2129 8.50898 13.1603ZM9.50007 19.1068C9.50007 18.6963 9.83286 18.3635 10.2434 18.3635H14.2077C14.6182 18.3635 14.951 18.6963 14.951 19.1068C14.951 19.5174 14.6182 19.8501 14.2077 19.8501H10.2434C9.83286 19.8501 9.50007 19.5174 9.50007 19.1068Z" fill="#1C274C"/>
                                                                        <path d="M18.1721 4.24084V6.08888C17.8621 5.97932 17.5285 5.9197 17.181 5.9197H5.28796C4.7406 5.9197 4.29688 5.47598 4.29688 4.92862V4.8582C4.29688 4.32994 4.68532 3.88206 5.20827 3.80735L15.9096 2.27859C17.1037 2.10801 18.1721 3.03459 18.1721 4.24084Z" fill="#2F73FE"/>
                                                                        <path d="M18.1721 4.24084V6.08888C17.8621 5.97932 17.5285 5.9197 17.181 5.9197H5.28796C4.7406 5.9197 4.29688 5.47598 4.29688 4.92862V4.8582C4.29688 4.32994 4.68532 3.88206 5.20827 3.80735L15.9096 2.27859C17.1037 2.10801 18.1721 3.03459 18.1721 4.24084Z" fill="url(#paint0_linear_3110_7668)"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7668" x1="7.77655" y1="4.17359" x2="17.7483" y2="4.48509" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>

                                                                </span>
                                                                <span class="title"> Brochure </span>
                                                            </a>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.claim_example && (currentSelectedPlan?.claim_example !== '' || currentSelectedPlan?.claim_example !== null)">
                                                            <a class="package-info-box" :href="currentSelectedPlan?.claim_example">
                                                                <span class="icon-holder">
                                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.86914 5.26123V19.1364C4.86914 20.7785 6.20031 22.1097 7.84239 22.1097H17.7532C19.3953 22.1097 20.7265 20.7785 20.7265 19.1364V9.22557C20.7265 7.58349 19.3953 6.25232 17.7532 6.25232H5.86023C5.31286 6.25232 4.86914 5.80859 4.86914 5.26123ZM8.09017 12.1988C8.09017 11.7883 8.42296 11.4555 8.83348 11.4555H16.7622C17.1727 11.4555 17.5055 11.7883 17.5055 12.1988C17.5055 12.6093 17.1727 12.9421 16.7622 12.9421H8.83348C8.42296 12.9421 8.09017 12.6093 8.09017 12.1988ZM8.09017 15.6676C8.09017 15.2571 8.42296 14.9243 8.83348 14.9243H14.2844C14.695 14.9243 15.0278 15.2571 15.0278 15.6676C15.0278 16.0781 14.695 16.4109 14.2844 16.4109H8.83348C8.42296 16.4109 8.09017 16.0781 8.09017 15.6676Z" fill="#1C274C"/>
                                                                        <path d="M18.7443 4.57336V6.4214C18.4343 6.31184 18.1007 6.25222 17.7532 6.25222H5.86023C5.31286 6.25222 4.86914 5.8085 4.86914 5.26114V5.19072C4.86914 4.66246 5.25758 4.21458 5.78054 4.13987L16.4818 2.61111C17.676 2.44053 18.7443 3.36711 18.7443 4.57336Z" fill="#2F73FE"/>
                                                                        <path d="M18.7443 4.57336V6.4214C18.4343 6.31184 18.1007 6.25222 17.7532 6.25222H5.86023C5.31286 6.25222 4.86914 5.8085 4.86914 5.26114V5.19072C4.86914 4.66246 5.25758 4.21458 5.78054 4.13987L16.4818 2.61111C17.676 2.44053 18.7443 3.36711 18.7443 4.57336Z" fill="url(#paint0_linear_3110_7663)"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3110_7663" x1="8.34881" y1="4.50611" x2="18.3206" y2="4.81761" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Policy Wording </span>
                                                            </a>
                                                        </li>
                                                        <li class="extra-info-list-item" v-if="currentSelectedPlan?.glossary && (currentSelectedPlan?.glossary !== '' || currentSelectedPlan?.glossary !== null)">
                                                            <a class="package-info-box" :href="currentSelectedPlan?.glossary">
                                                                <span class="icon-holder">
                                                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.220703 12.9547V2.29093C0.220703 1.24026 1.06397 0.386727 2.10684 0.45118C3.0358 0.508592 4.13445 0.622077 4.97791 0.845893C5.97617 1.11079 7.16252 1.67498 8.10078 2.17388C8.60921 2.44423 9.17373 2.57044 9.73512 2.55558V17.098C9.20174 17.098 8.66837 16.9688 8.18657 16.7106C7.23562 16.2008 6.00685 15.6098 4.97791 15.3368C4.14377 15.1155 3.06007 15.002 2.13772 14.944C1.08275 14.8777 0.220703 14.0176 0.220703 12.9547Z" fill="#2F73FE"/>
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.220703 12.9547V2.29093C0.220703 1.24026 1.06397 0.386727 2.10684 0.45118C3.0358 0.508592 4.13445 0.622077 4.97791 0.845893C5.97617 1.11079 7.16252 1.67498 8.10078 2.17388C8.60921 2.44423 9.17373 2.57044 9.73512 2.55558V17.098C9.20174 17.098 8.66837 16.9688 8.18657 16.7106C7.23562 16.2008 6.00685 15.6098 4.97791 15.3368C4.14377 15.1155 3.06007 15.002 2.13772 14.944C1.08275 14.8777 0.220703 14.0176 0.220703 12.9547Z" fill="url(#paint0_linear_3171_7650)"/>
                                                                        <path d="M19.2507 12.9677V2.27571C19.2507 1.25286 18.4456 0.413239 17.4259 0.448846C16.3521 0.486341 15.0139 0.5979 14.0178 0.896822C13.1543 1.15598 12.1485 1.67579 11.3289 2.1513C10.8388 2.43564 10.2891 2.58656 9.73633 2.60115V17.098C10.2697 17.098 10.8031 16.9692 11.2849 16.7118C12.2358 16.2037 13.4646 15.6145 14.4935 15.3423C15.3277 15.1217 16.4114 15.0086 17.3337 14.9508C18.3887 14.8846 19.2507 14.0273 19.2507 12.9677Z" fill="#1C274C"/>
                                                                        <defs>
                                                                        <linearGradient id="paint0_linear_3171_7650" x1="2.60676" y1="8.77286" x2="9.45105" y2="8.80659" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#2F73FE"/>
                                                                        <stop offset="1" stop-color="#4FADF8"/>
                                                                        </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="title"> Glossary </span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-md-4">
                                                    <h2> Summary Details </h2>
                                                    <div class="package-box selected-package-box" style="width:100%">
                                                        <div class="package-detail-box clearfix">
                                                            <div class="cart-head">
                                                                <strong class="title"> {{ currentSelectedPlan?.company_name }} </strong>
                                                                <span v-if="currentSelectedPlan?.plan_name" class="title-dot"> {{ currentSelectedPlan?.plan_name }} </span>
                                                                <span v-else class="title-dot"> {{ currentSelectedPlan?.product_name }} </span>
                                                            </div>
                                                            <div class="package-sum">
                                                                <ul>
                                                                    <li>
                                                                        <span class="sum-title"> Quote Validity </span>
                                                                        <span class="sum-value"> {{ currentSelectedPlan?.validity }} </span>
                                                                    </li>
                                                                    <li>
                                                                        <span v-if="currentSelectedPlan?.add_ons" class="sum-title"> Cover Limit </span>
                                                                        <span v-if="currentSelectedPlan?.add_ons" class="sum-value"> {{ currentSelectedPlan?.currency_symbol}}. {{ parseFloat(currentSelectedPlan?.sum_insured_value || 0).toLocaleString('en-US') }} </span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div v-if="serviceName != 'Health' && serviceName != 'Travel'" class="rate">
                                                                <span class="sum-title"> Rate </span>
                                                                <span class="sum-value"> {{ currentSelectedPlan?.net_premium_rate }} % </span>
                                                            </div>
                                                            <span class="package-grand"> <span class="premimum"> Premimum Amount {{ currentSelectedPlan.currency_symbol}}. </span> <strong> {{ parseFloat(currentSelectedPlan?.price || 0).toLocaleString('en-US') }} </strong> </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col align-right">
                                                    <button  @click.prevent="generateOrder(1)" class="btn btn-primary arrow-btn">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                        </svg>
                                                        Next 
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" :class="{ 'active show': isActive('upload-info') }" id="upload-info">
                                        <div class="package-user-detail-section">
                                            
                                            <div class="selected-package">
                                                <div class="package-detail-box clearfix">
                                                    <div class="package-detail-col">
                                                        <span class="package-logo"> <img :src="currentSelectedPlan.company_logo" :alt="currentSelectedPlan.company_name" /> </span>
                                                    </div>
                                                    <div class="package-detail-col">
                                                        <strong class="title"> {{currentSelectedPlan.product_name}} </strong>
                                                        <span v-if="currentSelectedPlan?.plan_name" class="title-dot"> {{ currentSelectedPlan?.plan_name }} </span>
                                                        <span v-else class="title-dot"> {{ currentSelectedPlan?.product_name }} </span>
                                                    </div>
                                                    <div class="package-detail-col total">
                                                        <span class="total-head"> Total </span>
                                                        <span class="total-head-grand"> {{ currentSelectedPlan?.currency_symbol}}.  {{ parseFloat(currentSelectedPlan?.price).toLocaleString('en-US') }} </span>
                                                    </div>
                                                    <div class="package-detail-col">
                                                        <span class="stat-title"> Premium Amount </span>
                                                        <span class="stat-number">  {{ currentSelectedPlan?.currency_symbol}}.  {{ parseFloat(currentSelectedPlan?.price).toLocaleString('en-US') }} </span>
                                                    </div>
                                                    <div class="package-detail-col">
                                                        <span class="stat-title"> Cover Limit </span>
                                                        <span class="stat-number">  {{ currentSelectedPlan?.currency_symbol}}. {{ parseFloat(currentSelectedPlan?.sum_insured_value).toLocaleString('en-US') }} </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="package-user-detail-tabs">
                                                <div class="nav-tab-wrapper mb-5">
                                                    <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                                        <li class="nav-item" role="presentation" v-for="(tab, key) in riskSectionTabs" :key="key" :class="tab">
                                                            <button class="nav-link" :button-id="key" :class="[key, tab, { active: isActiveSub(key)}]">
                                                                {{ tab }}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="tab-content user-tabs" id="pills-tabContent">
                                                    <div v-for="(tab, key) in riskSectionTabs" :key="key" class="tab-pane fade" :class="{ 'active show': isActiveSub(key) }" :button-id="key" :id="tab">
                                                        <div class="row">
                                                            <div v-for="(value,key) in dynamicTabData[key]" :key="key" class="col-md-6 mb-3" >
                                                                <div class="form-group">
                                                                    <label class="label block-label" :for="value.field_name"> {{value.label}} <em> * </em></label>
                                                                    <select :id="value.field_name" @change="setAdditionFormFieldValues($event)" v-if="value.type == 'dropDown' && value.field_name !== 'nationality'"  class="form-control">
                                                                        <option> -- Select -- </option>
                                                                        <option :value="options.id" :data-id="options.form_fields_id" v-for="(options , jKey) in value.default_values"> {{options.text}}</option>
                                                                    </select>

                                                                    <select :id="value.field_name" @change="setAdditionFormFieldValues($event)" v-else-if="value.field_name == 'nationality'"  class="form-control">
                                                                        <option> -- Select -- </option>
                                                                        <option data-id="408" value="6072">Pakistan</option>
                                                                        <template v-for="(options , jKey) in value.default_values">
                                                                            <option :value="options.id" :data-id="options.form_fields_id" v-if="options.text !== 'Pakistan'">
                                                                                {{options.text}}
                                                                            </option>
                                                                        </template>
                                                                    </select>
                                                                    
                                                                    <Datepicker
                                                                        v-else-if="value.type == 'date' && (value.field_name !== 'date_of_birth' && value.field_name !== 'survey_date')"
                                                                        ref="datepickers"
                                                                        class="form-control"
                                                                        :placeholder="value.label"
                                                                        :id="value.field_name"  
                                                                        :clearable="true"
                                                                        @update:modelValue="setAdditionFormFieldValues('datepicker', value, $event)"
                                                                        :value="AdditionalformSelectedFieldsValues[value.field_name]"
                                                                        @input="updateSelectedDate($event.target.value, value.field_name)"
                                                                    />
                                                                    <Datepicker
                                                                        v-else-if="value.field_name == 'survey_date'"
                                                                        ref="datepickers"
                                                                        class="form-control"
                                                                        :placeholder="value.label"
                                                                        :id="value.field_name"  
                                                                        :clearable="true"
                                                                        @update:modelValue="setAdditionFormFieldValues('datepicker', value, $event)"
                                                                        :lower-limit="minDay"
                                                                        :upper-limit="maxDay"
                                                                        :value="AdditionalformSelectedFieldsValues[value.field_name]"
                                                                        @input="updateSelectedDate($event.target.value, value.field_name)"
                                                                    />
                                                                    <!-- <input :id="value.field_name" @change="setAdditionFormFieldValues($event)" v-else-if="value.field_name == 'survey_date'" :value="value.label" :type="value.inputType" onfocus="(this.type='date')" onblur="(this.type='text')" :placeholder="value.label" class="form-control" :min="getMinDate()" :max="getMaxDate()" /> -->
                                                                    <Datepicker
                                                                        v-else-if="value.field_name == 'date_of_birth'"
                                                                        ref="datepickers"
                                                                        class="form-control"
                                                                        :placeholder="value.label"
                                                                        :id="value.field_name"  
                                                                        :clearable="true"
                                                                        @update:modelValue="setAdditionFormFieldValues('datepicker', value, $event)"
                                                                        :upper-limit="maxDate"
                                                                        :value="AdditionalformSelectedFieldsValues[value.field_name]"
                                                                        @input="updateSelectedDate($event.target.value, value.field_name)"
                                                                    />
                                                                    <!-- <input :id="value.field_name" @change="setAdditionFormFieldValues($event)" v-else-if="value.field_name == 'date_of_birth'" :max="maximumDate" :type="value.inputType" :value="value.label" onfocus="(this.type='date')" onblur="(this.type='text')" :placeholder="value.label" class="form-control" /> -->
                                                                    <input :id="value.field_name" @change="setAdditionFormFieldValues($event)" @keypress="checkNumber" v-else-if="value.field_name == 'cnic_number'" type="text" maxlength="13" placeholder="Type here" class="form-control" />
                                                                    <input :id="value.field_name" @change="setAdditionFormFieldValues($event)" @keypress="checkNumber" v-else-if="value.field_name == 'mobile_no'" type="text" maxlength="11" placeholder="Type here" class="form-control" />
                                                                    <!-- <input :id="value.field_name" @change="setAdditionFormFieldValues($event)" v-else-if="value.field_name == 'cnic_expiry' || value.field_name == 'cnic_expirydate'" :value="value.label" :type="value.inputType" onfocus="(this.type='date')" onblur="(this.type='text')" :placeholder="value.label" class="form-control" /> -->
                                                                    <input :id="value.field_name" @keyup="setAdditionFormFieldValues($event)" v-else :type="value.inputType" :placeholder="value.label" class="form-control" />
                                                                    <label :for="value.field_name"  v-if="value.type == 'text'" class="absolute-label"> {{ value.field_name }} *</label>
                                                                    <span class="text-danger" v-if="validations[value.field_name]">{{validations[value.field_name][0]}}</span>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div v-if="tab=='Documents'">
                                                            

                                                        <div class="row">
                                                            <div v-for="(value,key) in riskDocuments.documents" :key="key" class="upload-outer" >
                                                                <div class="upload-documents-inner mb-4">
                                                                    <h2 v-if="uploadedFiles[value.field_name]"> {{ value.label }} </h2>
                                                                    <div class="uploaded-files mb-3" v-if="uploadedFiles[value.field_name]">
                                                                        <div class="uploaded-files mb-3" v-for="(file, index) in uploadedFiles[value.field_name]" :key="index" :id="`file-${value.field_name+'-'+index}`">
                                                                            <!-- <span style="margin:0 25px 0 0; displa: inline-block"> {{ file.name}} </span> -->
                                                                            <div class="image-holder">
                                                                                <div class="progress">
                                                                                    <div class="progress-bar"
                                                                                        role="progressbar"
                                                                                        :style="{ width: file.progress >= 100 ? '100%' : file.progress + '%' }"
                                                                                        aria-valuenow="0"
                                                                                        aria-valuemin="0"
                                                                                        aria-valuemax="100">
                                                                                    </div>
                                                                                </div>
                                                                                <img :src="file.url" />
                                                                                <!-- <svg v-if="file.progress >= 100" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z" fill="#34C759"/>
                                                                                </svg> -->

                                                                                <span v-if="file.progress >= 100" class="remove-icon" @click="removeFile(index, value.field_name)">
                                                                                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
                                                                                </span>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <label v-else class="upload-thumb" :for="value.field_name"> 
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 13V17H10V13H7L11.65 8.35C11.85 8.15 12.16 8.15 12.36 8.35L17 13H14Z" fill="#007AFF"/>
                                                                        </svg>
                                                                        {{ value.label }} *
                                                                        <input :id="value.field_name" @change="getDocument($event, value.field_name)" multiple type="file" />
                                                                    </label>

                                                                    <label v-if="uploadedFiles[value.field_name]" class="btn btn-primary" :for="value.field_name"> 
                                                                        Add More +
                                                                        <input :id="value.field_name" @change="getDocument($event, value.field_name)" multiple type="file" />
                                                                    </label>
                                                                    
                                                                    <span class="text-danger" v-if="validations[value.field_name]">{{validations[value.field_name][0]}}</span>

                                                                </div>
                                                            </div>

                                                            <div v-for="(value,key) in riskDocuments.inspection_images" :key="key" class="upload-outer" >
                                                                
                                                                <div class="upload-documents-inner mb-4">
                                                                    <h2 v-if="uploadedFiles[value.field_name]"> {{ value.label }} </h2>
                                                                    <div class="uploaded-files mb-3" v-if="uploadedFiles[value.field_name]">
                                                                        <div class="uploaded-files" v-for="(file, index) in uploadedFiles[value.field_name]" :key="index" :id="`file-${value.field_name+'-'+index}`">
                                                                            <span style="margin:0 25px 0 0; displa: inline-block"> {{ file.name}} </span>
                                                                            <!-- <img :src="file.url" /> -->
                                                                            <svg v-if="file.progress >= 100" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z" fill="#34C759"/>
                                                                            </svg>

                                                                            <span v-if="file.progress >= 100" class="remove-icon" @click="removeFile(index, value.field_name)">
                                                                                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
                                                                            </span>
                                                                            <div class="progress">
                                                                                <div class="progress-bar"
                                                                                    role="progressbar"
                                                                                    :style="{ width: file.progress >= 100 ? '100%' : file.progress + '%' }"
                                                                                    aria-valuenow="0"
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <label v-else class="upload-thumb" :for="value.field_name"> 
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 13V17H10V13H7L11.65 8.35C11.85 8.15 12.16 8.15 12.36 8.35L17 13H14Z" fill="#007AFF"/>
                                                                        </svg>
                                                                        {{ value.label }} *
                                                                        <input :id="value.field_name" @change="getDocument($event, value.field_name)" multiple type="file" />
                                                                    </label>
                                                                    <span class="text-danger" v-if="validations[value.field_name]">{{validations[value.field_name][0]}}</span>
                                                                    
                                                                </div>
                                                                
                                                            </div>

                                                            
                                                        </div>
                                                        
                                                        </div>

                                                        <div class="row">
                                                            <div class="col align-right">
                                                                <button type="Submit" v-if="subActiveItem > 0" :button-id="key" @click.prevent="setActiveSubBack(key-1)" class="btn btn-primary me-2">
                                                                    <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                                    </svg> -->
                                                                    Back 
                                                                </button>
                                                                <button type="Submit" v-if="tab === getLastTab" @click.prevent="storeAdditionInfomation(2)" class="btn btn-primary active arrow-btn"> 
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                                    </svg>
                                                                    Next 
                                                                </button>
                                                                <button type="Submit" v-else :button-id="key" @click.prevent="setActiveSub(key+1)" class="btn btn-primary active arrow-btn">
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                                    </svg>
                                                                    Next 
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                    <div class="tab-pane fade" :class="{ 'active show': isActive('payment') }" id="payment">
                                        <div class="payment-methods">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h1 class="mb-4"> Choose Payment Method </h1>
                                                </div>
                                                <div class="col">
                                                    <ul class="payment-methods-list">
                                                        <li class="payment-methods-list-item radio-inner" v-for="(value,key) in paymentMethods" :key="key">
                                                            <label class="check-holder" :for="value.id">
                                                                <span class="logo-holder">
                                                                    <img v-if="value.payment_method == 'Cash'" src="../assets/images/cod-icon.png" />
                                                                    <img v-if="value.payment_method == 'Credit_Card'" src="../assets/images/payfast-icon.png" />
                                                                </span>
                                                                <span class="title"> {{ value.name }} </span>
                                                                <input :id="value.id"  
                                                                v-model="slectedPaymentMethod" type="radio" name="paymentMethod" :value="value.payment_method" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <form id='PayFast_payment_form' hidden name='PayFast-payment-form' method='post' action="https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction">
                                                    <input type="text" hidden name="CURRENCY_CODE" value="PKR"/><br/>
                                                    <input type="text" hidden name="MERCHANT_ID" :value="paymentMerchantID"/><br/>
                                                    <input type="text" hidden name="MERCHANT_NAME" :value="paymentMerchantName"/><br/>
                                                    <input type="text" hidden name="TOKEN" :value="paymentToken"/><br/>
                                                    <input type="text" hidden name="SUCCESS_URL" :value="paymentUrl+currentSelectedPlan.plan_id+'/'+subClassId+'/'+ozoneToken"/><br/>
                                                    <input type="text" hidden name="FAILURE_URL" :value="paymentUrl+currentSelectedPlan.plan_id+'/'+subClassId+'/'+ozoneToken"/><br/>
                                                    <input type="text" hidden name="CHECKOUT_URL" :value="paymentUrl+currentSelectedPlan.plan_id+'/'+subClassId+'/'+ozoneToken"/><br/>
                                                    <input type="text" hidden name="CUSTOMER_EMAIL_ADDRESS" :value="AdditionalformSelectedFieldsValues.email"/><br/>
                                                    <input type="text" hidden name="CUSTOMER_MOBILE_NO" :value="AdditionalformSelectedFieldsValues.mobile_no"/><br/>
                                                    <input type="text" hidden name="TXNAMT" :value="currentSelectedPlan.price"/><br/>
                                                    <input type="text" hidden name="BASKET_ID" :value="customerQoutation.customer_quotation_id"/><br/>
                                                    <input type="text" hidden name="ORDER_DATE" :value="paymentDate"/><br/>
                                                    <input type="text" hidden name="SIGNATURE" :value="signature"/><br/>
                                                    <input type="text" hidden name="VERSION" :value="version"/><br/>
                                                    <input  type="text" hidden name="TXNDESC" :value="txnDesc"/><br/>
                                                    <input type="text" hidden name="PROCCODE" :value="procCode"/><br/>
                                                    <input  type="text" hidden name="TRAN_TYPE" :value='tranType'/><br/>
                                                    <input type="hidden" NAME="MERCHANT_USERAGENT" value="Mozilla/5.0
                                                (Windows NT 6.1; Win64; x64; rv:47.0) Gecko/20100101 Firefox/47.0">
                                                    <input type="hidden" NAME="ITEMS[0][SKU]" value="INSURANCE-SKU-01">
                                                    <input type="hidden" NAME="ITEMS[0][NAME]" value="Insurance">
                                                    <input type="hidden" NAME="ITEMS[0][PRICE]" value="500">
                                                    <input type="hidden" NAME="ITEMS[0][QTY]" value="1">
                                                    <button ref="payfastForm" type="submit"></button>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="row mt-5">
                                            <div class="col align-right">
                                                <button type="Submit" @click.prevent="storePaymentMethod()" class="btn btn-primary arrow-btn">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                    </svg>
                                                    Next 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" :class="{ 'active show': isActive('summary') }" id="summary">
                                        <!-- {{ customerSummary }} -->
                                        <div class="summary-main">
                                            <h1> Customer Summary Details </h1>
                                            <div class="head-section">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <p> Order No : <span> {{customerSummary?.tcn_no}} </span> </p>
                                                        <p> Order Date : <span> {{customerSummary?.created_at}} </span> </p>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <i v-if="customerSummary?.class_name === 'Motor'"> <span>DISCLAIMER: </span>
                                                        "This document only serves as an acknowledgment of an order placed by you on our website/app and by no means is a confirmation of your insurance coverage. Your coverage will only start once the satisfactory physical inspection is completed, and the Insurer issues the Cover note/Policy. The issued cover note/policy will then be available to you digitally within the App and on the website."
                                                        </i>
                                                        <i v-else> <span>DISCLAIMER: </span>
                                                        "This document only serves the purpose of acknowledging the order placed by you on our website/app and by no means is a confirmation of your policy approval and/or issuance. Your policy Coverage will only start once the Insurer approves and issues the policy in accordance with the terms and conditions of the Insurer. The issued policy will then be made available to you digitally within the app. You acknowledge and agree that you have read, understand, and agree to be bound by, and comply with the terms and conditions and privacy policy of Inxurehub as found on our website/app".
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="summary-detail-box">
                                                <h2> Product Detail </h2>
                                                <div class="row">
                                                    <div class="col-md-3 mb-3">
                                                        <label>Major Class</label>
                                                        <p>{{customerSummary?.class_name}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label>Sub Class</label>
                                                        <p>{{customerSummary?.sub_class_name}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label>Company</label>
                                                        <p>{{customerSummary?.company}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label>Product / Plan</label>
                                                        <p>{{customerSummary?.product_name}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <div class="summary-detail-box">
                                                <h2> Quote Information </h2>
                                                <div class="row">
                                                    <template v-if="customerSummary?.risks">
                                                        <template v-for="(value, key) in customerSummary?.risks[0]?.form_data">
                                                            <template v-if="key === 'stage_1'">
                                                                <div v-for="(stageValue, stageKey) in value" :key="stageKey" class="col-md-3 mb-3">
                                                                    <label>{{stageValue?.label}}</label>
                                                                    <p>{{stageValue?.value}}</p>
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div> -->

                                            <div class="summary-detail-box" v-for="(value, key) in customerSummary.sections" :key="key">
                                                <h2> {{ value?.section_name }} </h2>
                                                <div class="row">
                                                    <div class="col-md-3 mb-3" v-for="(innervalue, innerkey) in value?.insidedetails" :key="innerkey">
                                                        <label> {{ innervalue.key }} </label>
                                                        <p v-html="formatValue(innervalue.value)"> </p>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                            <!-- <div class="summary-detail-box">
                                                <h2> Insured Detail </h2>
                                                <div class="row">
                                                    
                                                    <div class="col-md-3 mb-3">
                                                        <label> First Name: </label>
                                                        <p>{{customerSummary?.filled_other_data?.first_name}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label> Last Name: </label>
                                                        <p>{{customerSummary?.filled_other_data?.last_name}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label> City: </label>
                                                        <p>{{customerSummary?.filled_other_data?.city}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label> CNIC: </label>
                                                        <p>{{customerSummary?.filled_other_data?.cnic_number}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label> Email ID: </label>
                                                        <p>{{customerSummary?.filled_other_data?.email_id}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label> Number: </label>
                                                        <p>{{customerSummary?.filled_other_data?.mobile_no}}</p>
                                                    </div>
                                                    <div class="col-md-3 mb-3">
                                                        <label> Address: </label>
                                                        <p>{{customerSummary?.filled_other_data?.address}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="summary-detail-box">
                                                <h2> Sum Insured Detail </h2>
                                                <div class="row">
                                                    <div class="col-md-3 mb-3">
                                                        <label>Sum Insured:</label>
                                                        <p>{{customerSummary?.payload?.product_price}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="summary-detail-box mb-5">
                                                <h2> Premium Detail </h2>
                                                <div class="row">
                                                    <div class="col-md-3 mb-3">
                                                        <label>Payment Status</label>
                                                        <p>{{customerSummary?.payment_status}}</p>
                                                    </div>
                                                </div>
                                            </div> -->

                                            <div class="chk-inner">
                                                <label class="check-holder mt-3">
                                                    I HEREBY AGREE AND CONFIRM THAT ALL MY PERSONAL AND POLICY INFORMATION STATED HERE ARE CORRECT.
                                                    <input type="checkbox" v-model="termsAccept">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col align-right">
                                                    <button type="Submit" :disabled="!termsAccept" @click.prevent="getPaymentMethods(3)" class="btn btn-primary arrow-btn"> 
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M22 12C22 17.52 17.51 22 12 22L11.7202 21.9962C6.32942 21.8478 2 17.4264 2 12C2 6.49 6.48 2 12 2C17.51 2 22 6.49 22 12ZM14.79 12C14.79 11.8 14.71 11.61 14.57 11.47L11.08 8C10.94 7.85 10.75 7.78 10.56 7.78C10.36 7.78 10.17 7.85 10.02 8C9.73 8.3 9.73 8.77 10.03 9.06L12.98 12L10.03 14.94C9.73 15.23 9.73 15.71 10.02 16C10.32 16.3 10.79 16.3 11.08 16L14.57 12.53C14.71 12.39 14.79 12.2 14.79 12Z" fill="#2F80ED"/>
                                                        </svg>
                                                        Next 
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <img v-if="serviceName == 'Motor'" class="w-100" src="../assets/images/vehicle-ins-ani.gif" />
        <img v-if="serviceName == 'Health'" class="w-100" src="../assets/images/health-footer-image.png" />
        <img v-if="serviceName == 'PA'" class="w-100" src="../assets/images/pa-footer-image.png" />
        <img v-if="serviceName == 'Travel'" class="w-100" src="../assets/images/travel-ins-ani.gif" />
        <!-- <div>
            <input type="file" multiple @change="handleFileUpload">
            <ul>
            <li v-for="fileName in uploadedFiles" :key="fileName">{{ fileName }}</li>
            </ul>
        </div> -->
    </div>
    <SignupModal ref="SignupModal"></SignupModal>
    <LoginModal ref="LoginModal"></LoginModal>
    <CongratulationsModal ref="CongratulationsModal"></CongratulationsModal>
    <PackageInfoModal ref="PackageInfoModal"></PackageInfoModal>
</template>

<script>
    import axios from 'axios'
    import LoginModal from './patials/LoginModal.vue'
    import CongratulationsModal from './patials/CongratulationsModal.vue'
    import PackageInfoModal from './patials/PackageInfoModal.vue'
    import SignupModal from './patials/SignUpModal.vue'
    import VueMultiselect from 'vue-multiselect'
    import Datepicker from 'vue3-datepicker'
    export default {
      components:{
        LoginModal,
        SignupModal,
        PackageInfoModal,
        VueMultiselect,
        Datepicker,
        CongratulationsModal
      },
      data(){
        return{
            selectedDate: null,
            options: ['list', 'of', 'options'],
            myInputModel: '',
            currentSelectedPlan : {},
            paymentToken:'',
            paymentMerchantID:'',
            paymentMerchantName:'',
            paymentDate:'',
            procCode:'',
            signature:'',
            tranType:'',
            txnDesc:'',
            version:'',
            paymentUrl:'https://application.inxurehub.com/api/payment-final-payfast/',
            paymentLocalUrl:'https://inxurehub.com/feature-form/',
            formSelectedFieldsValues : {},
            dropDownValue:"",
            showDetailsBox: false,
            showUserDetail: false,
            activeItem: 'personelDetail',
            subActiveItem: 0,
            serviceName:"",
            serviceLogo:"",
            subClassName: "",
            subClassId: "",
            subClassForm: [],
            subClassFormValues: [],
            formFieldValues: [],
            validations:{},
            productPlans: [],
            insureDetail : {},
            ContactDetail : {},
            VehicleDetail : {},
            InspectionImages : {},
            AdditionalInfoImage:{},
            uploadedImagesName:{},
            uploadedDocImage: [],
            GetAdditionInfoDoc:[],
            riskSection: {},
            riskSectionTabs:[],
            dynamicTabData: {},
            dynFields:{},
            getLastTab: '',
            isShowing: true,
            finalValidationsFields: {},
            ozoneToken:'',
            subClassInnerCategories: [],
            customerSummary: [],
            termsAccept: false,
            uploadedFiles: {},
            imageSrc: null,
            riskDocuments: null,
            InspectionImagesLocal:[
                { id: 1, field_name: 'image1', label: 'Upload Image'},
                { id: 2, field_name: 'image2', label: 'Upload Image'},
                { id: 3, field_name: 'image3', label: 'Upload Image'},
                { id: 4, field_name: 'image4', label: 'Upload Image'}
            ],
            Documents : {},
            customerQoutation: {},
            AdditionalformSelectedFieldsValues: {},
            paymentMethods: {},
            slectedPaymentMethod:'',
            paymentInfo:{},
            subClassesList : [],
            congratulations: false,
            loader: false,
            showVehicleImages: false,
            apiUrl: process.env.VUE_APP_API_URL,
            IsDisablebTabs: false,
            activeSubclassIndex: 0,
            words: "",
            activeIndex: 'one',
            progress: 0,
            completedSteps: [],
            mainSteps: ['personelDetail', 'package', 'upload-info', 'summary', 'payment'],
            filteredCompanies: [],
            filteredCompany: '',
            sortPrice: '',
            sortByDate: ''
        }
      },
      methods: {
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            formatValue(value) {
                if (this.isEmail(value)) {
                    return this.breakStringEveryNCharacters(value, 10);
                }
                return value;
            },
            isEmail(value) {
                return value.includes("@") && value.includes(".");
            },
            breakStringEveryNCharacters(str, n) {
                if (str.length <= n) {
                    return str;
                }

                let result = '';
                for (let i = 0; i < str.length; i += n) {
                    result += str.slice(i, i + n) + '<br>';
                }

                return result;
            },
          selectSubClass(index){
              console.log(index)
              this.activeSubclassIndex = index
          },
          updateSelectedDate(value, fieldName) {
            const parts = value.split('-');
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            this.selectedDate = new Date(year, month, day);
        },
        packageExtraInfo(type){
            console.log(type);
            this.$refs.PackageInfoModal.selectedPackageName = type
            if(type === 'ProductDetail'){
                this.$refs.PackageInfoModal.selectedPackage = this.currentSelectedPlan.product_description;
                console.log(this.$refs.PackageInfoModal.selectedPackage)
            }
            if(type === 'TermsConditions'){
                this.$refs.PackageInfoModal.selectedPackage = this.currentSelectedPlan.things_to_note;
                console.log(this.$refs.PackageInfoModal.selectedPackage)
            }
            if(type === 'WhyBuy'){
                this.$refs.PackageInfoModal.selectedPackage = this.currentSelectedPlan.why_buy;
                console.log(this.$refs.PackageInfoModal.selectedPackage)
            }
            if(type === 'Coverages'){
                this.$refs.PackageInfoModal.selectedPackage = this.currentSelectedPlan.covers;
                console.log(this.$refs.PackageInfoModal.selectedPackage)
            }
            if(type === 'Exclusions'){
                this.$refs.PackageInfoModal.selectedPackage = this.currentSelectedPlan.exclusions;
                console.log(this.$refs.PackageInfoModal.selectedPackage)
            }
            this.$refs.PackageInfoModal.modal.show()
            // this.$refs.PackageInfoModal.selectedPackage = this.currentSelectedPlan;
            
        },
        getMinDate() {
            const today = new Date();
            const minDate = new Date(today.getTime() + 24 * 60 * 60 * 1000);
            return minDate.toISOString().split('T')[0];
        },
        getMaxDate() {
            const today = new Date();
            const maxDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000);
            return maxDate.toISOString().split('T')[0];
        },
        checkNumber(event) {
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
        },
        showDetails(currentPlan){
            this.currentSelectedPlan = currentPlan
            this.showDetailsBox = true
        },
        openSignup(){
            this.$refs.LoginModal.modal.hide()
            this.$refs.SignupModal.modal.show()
            
        },
        getPaymentMethods(index){
            let _this=this;
            let url=_this.apiUrl+'get-payment-methods';
            let customer_quotation_id = _this.customerQoutation.customer_quotation_id;
            let localToken = "Bearer " + localStorage.getItem('local_token')
            let axiosConfig = {
                customer_quotation_id,
                amount: _this.currentSelectedPlan.price
            };
            axios
            .post(url, axiosConfig ,{
                headers: {
                    'Authorization': `${localToken}`
                },
            })
            .then((response) => {
                console.log('ssdsdsd response');
                console.log(response);
                if(response.data.response_code==200){
                    _this.paymentToken = response.data.data.token
                    _this.paymentDate = response.data.data.date
                    _this.paymentMerchantID = response.data.data.merchantId
                    _this.paymentMerchantName = response.data.data.merchantName
                    _this.procCode = response.data.data.procCode
                    _this.signature = response.data.data.signature
                    _this.tranType = response.data.data.tranType
                    _this.txnDesc = response.data.data.txnDesc
                    _this.version = response.data.data.version
                    _this.paymentMethods = response.data.data.payment_methods
                    _this.completedSteps.push(index);
                    _this.activeItem = "payment"
                    
                }
            })
            .catch((e) => {
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
            });
        },
        getSummary(){
            let _this=this;
            let url=_this.apiUrl+'PolicyDetail';
            let id = _this.customerQoutation.customer_quotation_id;
            // let id = '9341';
            let localToken = "Bearer " + localStorage.getItem('local_token')
            let axiosConfig = {
                id
            };
            axios
            .post(url, axiosConfig ,{
                headers: {
                    'Authorization': `${localToken}`
                },
            })
            .then((response) => {
                console.log('summary detail response');
                // console.log(response);
                _this.customerSummary = response.data;
                console.log("_this.customerSummary:")
                console.log(_this.customerSummary)
                // if(response.data.response_code==200){
                //     _this.paymentToken = response.data.data.token
                //     _this.paymentDate = response.data.data.date
                //     _this.paymentMerchantID = response.data.data.merchantId
                //     _this.paymentMerchantName = response.data.data.merchantName
                //     _this.procCode = response.data.data.procCode
                //     _this.signature = response.data.data.signature
                //     _this.tranType = response.data.data.tranType
                //     _this.txnDesc = response.data.data.txnDesc
                //     _this.version = response.data.data.version
                //     _this.paymentMethods = response.data.data.payment_methods
                // }
            })
            .catch((e) => {
                console.log(e)
                // if(e.response.data.success==false){
                //     this.$swal.fire({
                //         icon: 'error',
                //         title: 'Oops...',
                //         text: 'Something went wrong.'
                //     })
                // }
            });
        },
        storePaymentMethod(){
            let _this=this;
            let url=_this.apiUrl+'store-payment-info';

            this.paymentInfo['sub_class_id'] = _this.subClassId;
            this.paymentInfo['customer_quotation_id'] = _this.customerQoutation.customer_quotation_id;
            this.paymentInfo['plan_id'] = _this.currentSelectedPlan.plan_id;
            this.paymentInfo['paid_amount'] = _this.currentSelectedPlan.price;
            this.paymentInfo['payment_method'] = _this.slectedPaymentMethod.toLowerCase();

            if(_this.slectedPaymentMethod == 'Credit_Card'){
                this.$refs.payfastForm.click()
            }
            const formDatas = this.paymentInfo;
            let localToken = "Bearer " + localStorage.getItem('local_token')
            let data = {
                formDatas
            }
            axios
            .post(url, data, {
                headers: {
                    'Authorization': `${localToken}`
                },
            })
            .then((response) => {
                // console.log(response);
                if(response.data.response_code==200){
                    this.$refs.CongratulationsModal.modal.show()
                    // _this.congratulations = true
                    // _this.activeItem = "summary"
                    this.$router.push('/')
                }
            })
            .catch((e) => {
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
            });
        },
        getFilterCopanies(){
            let _this=this;
            let url=_this.apiUrl+'company/list';
            axios
            .get(url, {
                
            })
            .then((response) => {
                console.log(response.data);
                _this.filteredCompanies = response.data
                
            })
            .catch((e) => {
                
            });
        },
        
        getFilteredByPrice(e){
            let _this=this;
            let url=_this.apiUrl+'product/list';
            this.formSelectedFieldsValues["sub_class_id"] = _this.subClassId;
            this.loader = true

            console.log(this.formSelectedFieldsValues);
            // let priceValue = e.target.value;
            // let minPrice = '';
            // let maxPrice = '';
            // if(priceValue === 'ASC'){
            //     minPrice = 'ASC'
            // }
            // if(priceValue === 'DESC'){
            //     maxPrice = 'DESC'
            // }

            let formDatas = this.formSelectedFieldsValues;
            let totalFields = _this.subClassForm;
            let emptyFields = [];
            for (let field of totalFields) {
                if (!formDatas[field.field_name]) {
                    emptyFields.push(field.field_name);
                    formDatas[field.field_name] = "";
                }
            }
            let axiosConfig = {
                sorting_key: 'price',
                // min_price: minPrice,
                // max_price: maxPrice,
                sorting: _this.sortPrice,
                formDatas
            };
            axios
            .post(url, axiosConfig)
            .then((response) => {
                if(response.data.response_code==200){
                    _this.productPlans = response.data.data
                    
                }
                
            })
            .catch((e) => {
                console.log('errors')
                console.log(e)
                _this.validations=e.response.data.errors;
                console.log(_this.validations)
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
                
            }).finally(() => {
                this.loader = false
            }) 

        },

        getFilteredByDate(e){
            let _this=this;
            let url=_this.apiUrl+'product/list';
            this.formSelectedFieldsValues["sub_class_id"] = _this.subClassId;
            this.loader = true

            console.log(this.formSelectedFieldsValues);

            // const entries = Object.entries(this.formSelectedFieldsValues);

            let formDatas = this.formSelectedFieldsValues;
            let totalFields = _this.subClassForm;
            let emptyFields = [];
            for (let field of totalFields) {
                if (!formDatas[field.field_name]) {
                    emptyFields.push(field.field_name);
                    formDatas[field.field_name] = "";
                }
            }
            let axiosConfig = {
                sorting_key: 'date',
                sorting: _this.sortByDate,
                formDatas
            };
            axios
            .post(url, axiosConfig)
            .then((response) => {
                if(response.data.response_code==200){
                    _this.productPlans = response.data.data
                    
                }
                
            })
            .catch((e) => {
                console.log('errors')
                console.log(e)
                _this.validations=e.response.data.errors;
                console.log(_this.validations)
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
                
            }).finally(() => {
                this.loader = false
            }) 

        },

        getFilteredCompany(e){
            let _this=this;
            let url=_this.apiUrl+'product/list';
            this.formSelectedFieldsValues["sub_class_id"] = _this.subClassId;
            this.loader = true

            console.log(this.formSelectedFieldsValues);

            // const entries = Object.entries(this.formSelectedFieldsValues);

            let formDatas = this.formSelectedFieldsValues;
            let totalFields = _this.subClassForm;
            let emptyFields = [];
            for (let field of totalFields) {
                if (!formDatas[field.field_name]) {
                    emptyFields.push(field.field_name);
                    formDatas[field.field_name] = "";
                }
            }
            let axiosConfig = {
                sorting_key: 'company',
                company: _this.filteredCompany,
                formDatas
            };
            axios
            .post(url, axiosConfig)
            .then((response) => {
                if(response.data.response_code==200){
                    _this.productPlans = response.data.data
                    
                }
                
            })
            .catch((e) => {
                console.log('errors')
                console.log(e)
                _this.validations=e.response.data.errors;
                console.log(_this.validations)
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
                
            }).finally(() => {
                this.loader = false
            }) 

        },
        getProductPlanList(index){
            this.scrollToTop();
            let _this=this;
            let url=_this.apiUrl+'product/list';
            this.getFilterCopanies();
            this.formSelectedFieldsValues["sub_class_id"] = _this.subClassId;
            this.loader = true

            console.log(this.formSelectedFieldsValues);

            // const entries = Object.entries(this.formSelectedFieldsValues);

            let formDatas = this.formSelectedFieldsValues;
            let totalFields = _this.subClassForm;
            let emptyFields = [];
            let param = "";
            for (let field of totalFields) {
                if (!formDatas[field.field_name]) {
                    emptyFields.push(field.field_name);
                    formDatas[field.field_name] = "";
                }
            }
            let axiosConfig = {
                formDatas
            };
            axios
            .post(url, axiosConfig)
            .then((response) => {
                //console.log(response)
                if(response.data.response_code==200){
                    _this.productPlans = response.data.data
                    console.log("Plans" + _this.productPlans)
                    _this.activeItem = "package"
                    _this.IsDisablebTabs = true

                    _this.completedSteps.push(index);
                    console.log('_this.completedSteps')
                    console.log(_this.completedSteps)
                }
                
            })
            .catch((e) => {
                console.log('errors')
                console.log(e)
                _this.validations=e.response.data.errors;
                console.log(_this.validations)
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
                
            }).finally(() => {
                this.loader = false
            }) 
            // this.activeItem = 'package'
        },
        generateOrder(index){
            let _this=this;
            let url=_this.apiUrl+'order/generate';
            this.loader = true
            this.formSelectedFieldsValues["plan_id"] = _this.currentSelectedPlan.plan_id;
            this.formSelectedFieldsValues["product_price"] = _this.currentSelectedPlan.price;

            const formDatas = this.formSelectedFieldsValues;
            let localToken = "Bearer " + localStorage.getItem('local_token')
            // let ozoneToken = "Bearer " + localStorage.getItem('localToken')
            
            //console.log(ozoneToken);

            let axiosConfig = {
                formDatas,
            };
            axios
            .post(url, axiosConfig, {
                headers: {
                    'Authorization': `${localToken}`
                },
            })
            .then((response) => {
                //console.log(response)
                if(response.data.response_code==200){
                    _this.customerQoutation = response.data.data;
                    this.getUploadInformationForm();
                    //console.log(_this.customerQoutation);
                    _this.completedSteps.push(index);
                    _this.activeItem = "upload-info"
                }
            })
            .catch((e) => {
                console.log(e.response);
                // console.log()
                if(e.response.status==401){
                    this.$refs.LoginModal.modal.show()
                }
            }).finally(() => {
                this.loader = false
            });
            // this.activeItem = 'package'
        },
        getVehicleImage(event) {
            this.AdditionalInfoImage = event.target.files
        },
        removeFile(index, field_name) {
  // Remove the file from uploadedFiles
  const updatedFiles = { ...this.uploadedFiles };
  updatedFiles[field_name].splice(index, 1);

  // If there are no more files, remove the field from uploadedFiles
  if (updatedFiles[field_name].length === 0) {
    delete updatedFiles[field_name];
  }

  this.uploadedFiles = updatedFiles;
  console.log(this.uploadedFiles);
  this.GetAdditionInfoDoc[field_name] = this.uploadedFiles[field_name];
},
        getDocument(e, field_name) {
  const files = e.target.files;
  let newFiles = { ...this.uploadedFiles };

  if (!newFiles.hasOwnProperty(field_name)) {
    newFiles[field_name] = [];
  }

  for (let i = 0; i < files.length; i++) {
    let file = files[i];
    let progress = 0;

    const interval = setInterval(() => {
      if (progress < 100) {
        progress += 5;
        const updatedFiles = { ...newFiles };
        const fileIndex = updatedFiles[field_name].findIndex((item) => item.file === file);
        if (fileIndex !== -1) {
          updatedFiles[field_name][fileIndex].progress = progress;
          this.uploadedFiles = updatedFiles;
        }
      } else {
        clearInterval(interval);
      }
    }, 200);

    newFiles[field_name].push({
      name: file.name,
      file: file,
      url: URL.createObjectURL(file),
      progress: progress,
    });
  }

  this.GetAdditionInfoDoc[e.target.id] = files;
  console.log(this.uploadedFiles);
  this.GetAdditionInfoDoc = this.uploadedFiles;
},
        setFormFieldValuesObject(event, value, e){
            if (event === 'datepicker') {
                const date = e?.toLocaleDateString('en-GB');
                const parts = date.split("/");
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10);
                const year = parseInt(parts[2], 10);
                const finalDate = `${day}-${month}-${year}`;
      this.formSelectedFieldsValues[value.field_name] = finalDate;
    } else {
      const inputElement = event.target;
      const numericValue = parseFloat(inputElement.value.replace(/[^0-9.]/g, ""));

      if (!isNaN(numericValue)) {
        const words = this.convertNumberToWords(numericValue);
        this.formSelectedFieldsValues[inputElement.id] = inputElement.value;
        this.words = words;
      } else {
        this.formSelectedFieldsValues[inputElement.id] = inputElement.value;
        this.words = "";
      }
      sessionStorage.setItem('formSelectedFieldsValues', JSON.stringify(this.formSelectedFieldsValues));
    }
    console.log(this.formSelectedFieldsValues);
  },
    convertNumberToWords(number) {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion'];

  function convertToWordsLessThanThousand(num) {
    if (num === 0) return '';
        const words = [];
        
        if (num >= 100) {
            words.push(units[Math.floor(num / 100)] + ' Hundred');
            num %= 100;
        }
        
        if (num >= 10 && num <= 19) {
            words.push(teens[num - 10]);
            num = 0;
        } else if (num >= 20) {
            words.push(tens[Math.floor(num / 10)]);
            num %= 10;
        }
        
        if (num > 0) {
            words.push(units[num]);
        }
        
        return words.join(' ');
    }

        function convertToWords(num) {
            if (num === 0) return 'Zero';
            
            let result = '';
            for (let i = 0; num > 0; i++) {
            if (num % 1000 !== 0) {
                result = `${convertToWordsLessThanThousand(num % 1000)} ${thousands[i]} ${result}`.trim();
            }
            num = Math.floor(num / 1000);
            }
            
            return result;
        }

        return convertToWords(number);
    },
        setFormRadio(event){
            this.formSelectedFieldsValues[event.target.name] = event.target.id;
            // sessionStorage.setItem('formSelectedFieldsValues', JSON.stringify(this.formSelectedFieldsValues));
            console.log(this.formSelectedFieldsValues);
        },
        setAdditionFormFieldValues(event, value, e){

            if (event === 'datepicker'){
                this.AdditionalformSelectedFieldsValues[value.field_name] = e?.toLocaleDateString('en-GB');
            // sessionStorage.setItem('formSelectedFieldsValues', JSON.stringify(this.formSelectedFieldsValues));
                console.log(this.AdditionalformSelectedFieldsValues);
            }
            else{
                this.AdditionalformSelectedFieldsValues[event.target.id] = event.target.value;
                console.log(this.AdditionalformSelectedFieldsValues);
            }
            // console.log(this.AdditionalformSelectedFieldsValues, event.target.id);
        },
        // setFormRadio(event){
        //     this.AdditionalformSelectedFieldsValues[event.target.name] = event.target.value;
        //     // console.log(this.AdditionalformSelectedFieldsValues, event.target.id);
        //     console.log(this.AdditionalformSelectedFieldsValues);
        // },
        storeAdditionInfomation(index){
            this.scrollToTop();
            let _this=this;
            let url=_this.apiUrl+'customer/store/quotation-additional-info';
            this.loader = true
            // console.log(_this.GetAdditionInfoDoc)
            this.AdditionalformSelectedFieldsValues["sub_class_id"] = _this.customerQoutation.subclass_id;
            this.AdditionalformSelectedFieldsValues["customer_quotation_id"] = _this.customerQoutation.customer_quotation_id;
            this.AdditionalformSelectedFieldsValues["quotation_risk_id"] = _this.customerQoutation.quotation_risk_id;
            // this.AdditionalformSelectedFieldsValues["vehicle_images"] = _this.AdditionalInfoImage;
            
            //this.AdditionalformSelectedFieldsValues["cnic"][0] = _this.GetAdditionInfoDoc.cnic;
            // this.AdditionalformSelectedFieldsValues["cnic"] = _this.GetAdditionInfoDoc.cnic;
            console.log("_this.uploadedFiles")
            console.log(_this.uploadedFiles)

            console.log("dynamicTabData sdssdsdsd")
            console.log(_this.dynamicTabData)

            let images = [];
            
            let obj = [];
            for(let key in _this.uploadedFiles){
                obj[key] = _this.uploadedFiles[key]
            }
            this.AdditionalformSelectedFieldsValues["images"] = obj;

            console.log(images);
            // additional inoformation validations
            
            
            // this.AdditionalformSelectedFieldsValues["date_of_birth"] = _this.formSelectedFieldsValues.date_of_birth;
            // this.AdditionalformSelectedFieldsValues["registration_book"] = _this.GetAdditionInfoDoc.registration_book;
            // this.AdditionalformSelectedFieldsValues["self_survey_video"] = _this.GetAdditionInfoDoc.self_survey_video;

            const formDatas = this.AdditionalformSelectedFieldsValues;

            let totalFields = [];
            let emptyFields = [];
            let param = "";
            console.log('Vehicle Images:',  _this.InspectionImages)
            for (let group of [...Object.keys(_this.dynamicTabData), ...Object.keys(_this.riskDocuments)]) {
                // console.log('group:', group);


                if (_this.dynamicTabData.hasOwnProperty(group)) {
                    for (let field of _this.dynamicTabData[group]) {
                        // console.log('field field_name:', field.field_name);
                        totalFields.push(field.field_name);
                    }
                }

                if (_this.riskDocuments.hasOwnProperty(group)) {
                    for (let field of _this.riskDocuments[group]) {
                        // console.log('field field_name:', field.field_name);
                        totalFields.push(field.field_name);
                    }
                }
            }
            for (let field of totalFields) {
                console.log(field)
                if (!formDatas[field]) {
                    emptyFields.push(field);
                    formDatas[field] = "";
                }
            }

            const data = new FormData();
            console.log(_this.riskDocuments)
            // console.log(data)

            // let localToken = localStorage.getItem('local_token')
            let localToken = "Bearer " + localStorage.getItem('local_token')
            // let ozoneToken = "Bearer " + localStorage.getItem('ozone_token')

            //console.log("formDatas");
            //console.log(formDatas);
            
            for (let key in formDatas) {
                if (formDatas.hasOwnProperty(key)) {
                    if(key == 'images'){
                        for (let images in formDatas[key]){
                            for (let file in formDatas[key][images]){
                                if(formDatas[key][images][file].file instanceof File){
                                    data.append(images+"[0][]",formDatas[key][images][file].file);
                                }
                            }
                        }
                        
                    }else{
                        data.append(key,formDatas[key]);
                    }
                }
            }
            console.log(data)

            // console.log("data");
            // console.log(data);
            // console.log(formDatas)
            let axiosConfig = {
                data,
            };
            axios
            .post(url, data, {
                headers: {
                    'Authorization': `${localToken}`,
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then((response) => {
                console.log(response)
                if(response.data.response_code==200){
                    // _this.getPaymentMethods();
                    _this.getSummary();
                    _this.completedSteps.push(index);
                    _this.activeItem = "summary"
                     
                }
            })
            .catch((e) => {
                _this.validations=e.response.data.errors;
                console.log(e)
                if(e.response.data.errors.code==403){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Your email address is not verified.'
                    })
                }
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
                var obj = {};
                for (var i = 0; i < _this.validations.length; i++) {
                  obj[(_this.validations[i].field)] = Object.values([_this.validations[i].message])
                }
                 _this.finalValidationsFields = obj
                console.log("_this.finalValidationsFields")
                console.log(_this.finalValidationsFields)
                
                
            }).finally(()=>{
                this.loader = false
            });


            
        },
        changeChild(childId,event){
            this.formSelectedFieldsValues[event.target.id] = event.target.value;
            // console.log(this.formSelectedFieldsValues, event.target.id);
            console.log(this.formSelectedFieldsValues);
            
            if(childId){
                

                // alert(event.target.value)
                let _this=this;
                this.loader = true
                let url=_this.apiUrl+'get_child_form_field_values';
                let axiosConfig = {
                    child_form_field_id : childId,
                    parent_value_id : event.target.value
                };
                axios
                .post(url, axiosConfig)
                .then((response) => {
                    // debugger
                    this.formFieldValues = response.data.data
                    for (let index = 0; index < this.subClassForm.length; index++) {
                        if(this.subClassForm[index].id == childId){
                            var i;
                            for(i = 0; i < this.formFieldValues.length; i++){
                                this.formFieldValues[i].text = this.formFieldValues[i]['text'];
                            }
                            this.subClassForm[index].defaultvaluesparent = this.formFieldValues;
                        }                        
                    }
                    if(response.data.code==200){}
                })
                .catch((e) => {
                    //console.log(e);
                    if(e.response.data.success==false){
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong.'
                        })
                    }
                }).finally(() => {
                    this.loader = false
                }) 
            }
        },
        continueToUserDetail(){
            this.showUserDetail = true
        },
        isActive (menuItem) {
            console.log(menuItem)
            return this.activeItem === menuItem;
        },
        isDone(index) {
            return this.completedSteps.includes(index);
        },
        setActive (menuItem) {
            this.activeItem = menuItem
        },

        isActiveSub (menuItem) {
            return this.subActiveItem === menuItem
            },
        setActiveSubBack(menuItem) {
            this.subActiveItem = menuItem;
        },
        setActiveSub(menuItem) {
            // Assuming 'this' refers to your Vue component
            this.scrollToTop();
            console.log(menuItem)
            let vm = this;
            if (!vm.dynamicTabData || !vm.dynamicTabData[menuItem - 1]) {
                console.error('Invalid menuItem or dynamicTabData is undefined.');
                return;
            }

            let currentTab = this.dynamicTabData[menuItem - 1];
            this.validations = {};

            // Flag to track if validation errors were found
            let validationErrorsFound = false;

            for (let i = 0; i < currentTab.length; i++) {
                const field_name = currentTab[i].field_name;
                const fieldValue = this.AdditionalformSelectedFieldsValues[field_name];

                if (!fieldValue || fieldValue.trim() === '') {
                vm.validations[field_name] = [`The ${currentTab[i].label} field is required.`];
                validationErrorsFound = true; // Set the flag to true if validation error is found
                }
            }

            if (!validationErrorsFound) {
                vm.subActiveItem = menuItem;
                vm.validations = {};
            }
         },
        // First SUb form API
        getSingleId(value){
            let vm = this
            
            this.subClassId = value.subclass_id;
            this.subClassName = value.name;
            // console.log('value.sub_classes')
            // console.log(value)
            // if(value.sub_classes){
            //     this.subClassInnerCategories = value.sub_classes
                
            // }

            this.getSubClassForm()
            
        },
        getSubClassForm() {
            let _this=this;
            let url=_this.apiUrl+'sub-class-form';
            this.loader = true
            let axiosConfig = {
                sub_class_id : _this.subClassId
            };
            axios
            .post(url, axiosConfig)
            .then((response) => {

                
                _this.subClassForm = response.data.data
                // console.log(_this.subClassForm);
                // console.log('sub class form response')
                // console.log(_this.subClassForm)

                // console.log('sub class form response full')

                // console.log(response)

                // let arr = response.data.classes;
                // vm.subClassesList = arr.subclasses;
                
                _this.serviceName = response.data.classes[0].name;
                _this.serviceLogo = response.data.classes[0]?.logo;
                
                _this.subClassesList = response.data.classes[0]?.categories;
                _this.serviceLogo = response.data.classes[0]?.logo;
                _this.subClassInnerCategories = response.data.classes[0]?.subclasses;

                if (_this.subClassId == '' || _this.subClassName == '') {
                    _this.subClassId = response.data.classes[0]?.subclasses[0]?.subclass_id;
                    _this.subClassName = response.data.classes[0].subclasses[0]?.name;
                }
                
                
                if(response.data.code==200){
                }
            })
            .catch((e) => {
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
            })
            .finally(() => {
                this.loader = false
            }) 
        },
        getUploadInformationForm() {
            let _this=this;
            let url=_this.apiUrl+'customer/quote-fields';
            const formDatas = this.customerQoutation;
            let localToken = "Bearer " + localStorage.getItem('local_token')
            // _this.ozoneToken = localStorage.getItem('ozone_token')
            let axiosConfig = {
                formDatas  
            };
            axios
            .post(url, axiosConfig, {
                headers: {
                    'Authorization': `${localToken}`
                },
            })
            .then((response) => {
                
                //  console.log(response)
                if(response.data.response_code==200){
                    _this.riskSection =  response.data.data.risk_sections;
                    _this.riskDocuments =  response.data.data.risk_documents;
                    _this.InspectionImages =  response.data.data.inspection_images;
                    console.log('_this.riskSection  123');
                    console.log(Object.getOwnPropertyNames(_this.riskSection));
                    const rsikTabsArr = [];
                    for(let i = 0; i < _this.riskSection.length;i++){
                        _this.riskSectionTabs[i] = _this.riskSection[i].section_name;
                    }
                    // _this.riskSectionTabs = Object.getOwnPropertyNames(_this.riskSection)
                    console.log('riskSectionTabs abc');
                    console.log(_this.riskSectionTabs.length);
                    _this.riskSectionTabs[_this.riskSectionTabs.length] =   "Documents";
                    
                     console.log("riskSectionTabs");
                     console.log(_this.riskSectionTabs);


                    let riskSectionTabsLength = _this.riskSectionTabs.length;

                    for(let i = 0;i < riskSectionTabsLength;i++){
                        let item = _this.riskSectionTabs[i];
                        if((i + 1) == (riskSectionTabsLength)){
                            _this.getLastTab = item
                            console.log("Last iteration with item : " + _this.getLastTab); 
                        }
                    }
                    let dynFields = [];
                    for (let key in _this.riskSection) {
                        if (_this.riskSection.hasOwnProperty(key)) {
                            _this.dynamicTabData[key] = []; 
                            for (let keyInner in _this.riskSection[key].custom_fields) {
                                if (_this.riskSection[key].custom_fields.hasOwnProperty(keyInner)) {
                                    (_this.dynamicTabData[key]).push(_this.riskSection[key].custom_fields[keyInner]);
                                }
                            }
                            
                        }
                    };

                    console.log("_this.dynamicTabData");
                    console.log(_this.dynamicTabData);



                // _this.InspectionImages =  response.data.data.risk_documents.inspection_images;
                   _this.Documents =  response.data.data.risk_documents;
                   //console.log(_this.Documents);
                  // console.log("_this.Documents");                   
                }
                
            })
            .catch((e) => {
                if(e.response.data.success==false){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong.'
                    })
                }
            });
        }
      },
      created(){
        
        let vm = this;
        const fullURL = window.location.href;
        const segments = fullURL.split('/');
        const alias = segments[segments.length - 1];
        let newSubClassID = alias;
        vm.subClassId = alias
        this.getSubClassForm();
        
      },
      mounted(){
        

      },
      computed: {
            maxDate() {
                const currentDate = new Date();
                const maxDate = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());
                return maxDate;
            },
            maxDay() {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() + 2);
                return currentDate;
            },
            minDay() {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate());
                return currentDate;
            },
            formattedDate() {
                if (this.selectedDate) {
                    const day = String(this.selectedDate.getDate()).padStart(2, '0');
                    const month = String(this.selectedDate.getMonth() + 1).padStart(2, '0');
                    const year = this.selectedDate.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            },
        },
      watch:{
            validations:function(){},
            // activeItem(newIndex) {
            //     sessionStorage.setItem('activeItem', newIndex)
            // }
            
        }
    }
</script>

<style>

    @keyframes confetti-slow {
  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }
  
  100% { transform: translate3d(25px, 105vh, 0) rotateX(360deg) rotateY(180deg); }
}

@keyframes confetti-medium {
  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }
  
  100% { transform: translate3d(100px, 105vh, 0) rotateX(100deg) rotateY(360deg); }
}

@keyframes confetti-fast {
  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }
  
  100% { transform: translate3d(-50px, 105vh, 0) rotateX(10deg) rotateY(250deg); }
}

.con-container {
  
  background: #ffffff;
  border:1px solid white;
    text-align: center;
  top:0px;
}
.form-submitted{
    padding: 150px 0;
    text-align: center;
}
.form-submitted h1{
    margin: 50px 0 0px;
}
.confetti-container {
  perspective: 700px;
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.confetti {
  position: absolute;
  z-index: 1;
  top: -10px;
  border-radius: 0%;

  &--animation-slow {
    animation: confetti-slow 2.25s linear 1 forwards;
  }
  
  &--animation-medium {
    animation: confetti-medium 1.75s linear 1 forwards;
  }
  
  &--animation-fast {
    animation: confetti-fast 1.25s linear 1 forwards;
  }
}





/* Checkmark */
.checkmark-circle {
  width: 150px;
  height: 150px;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-left: auto;
  margin-right: auto;
}
.checkmark-circle .background {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: #00C09D;
  position: absolute;
}
.checkmark-circle .checkmark {
  border-radius: 5px;
}
.checkmark-circle .checkmark.draw:after {
  -webkit-animation-delay: 100ms;
  -moz-animation-delay: 100ms;
  animation-delay: 100ms;
  -webkit-animation-duration: 3s;
  -moz-animation-duration: 3s;
  animation-duration: 3s;
  -webkit-animation-timing-function: ease;
  -moz-animation-timing-function: ease;
  animation-timing-function: ease;
  -webkit-animation-name: checkmark;
  -moz-animation-name: checkmark;
  animation-name: checkmark;
  -webkit-transform: scaleX(-1) rotate(135deg);
  -moz-transform: scaleX(-1) rotate(135deg);
  -ms-transform: scaleX(-1) rotate(135deg);
  -o-transform: scaleX(-1) rotate(135deg);
  transform: scaleX(-1) rotate(135deg);
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.checkmark-circle .checkmark:after {
  opacity: 1;
  height: 75px;
  width: 37.5px;
  -webkit-transform-origin: left top;
  -moz-transform-origin: left top;
  -ms-transform-origin: left top;
  -o-transform-origin: left top;
  transform-origin: left top;
  border-right: 15px solid white;
  border-top: 15px solid white;
  border-radius: 2.5px !important;
  content: '';
  left: 25px;
  top: 75px;
  position: absolute;
}

@-webkit-keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: 37.5px;
    opacity: 1;
  }
  40% {
    height: 75px;
    width: 37.5px;
    opacity: 1;
  }
  100% {
    height: 75px;
    width: 37.5px;
    opacity: 1;
  }
}
@-moz-keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: 37.5px;
    opacity: 1;
  }
  40% {
    height: 75px;
    width: 37.5px;
    opacity: 1;
  }
  100% {
    height: 75px;
    width: 37.5px;
    opacity: 1;
  }
}
@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: 37.5px;
    opacity: 1;
  }
  40% {
    height: 75px;
    width: 37.5px;
    opacity: 1;
  }
  100% {
    height: 75px;
    width: 37.5px;
    opacity: 1;
  }
}



.submit-btn {
    height: 45px;
    width: 200px;
    font-size: 15px;
    background-color: #00c09d;
    border: 1px solid #00ab8c;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(87,71,81,.2);
    cursor: pointer;
    transition: all 2s ease-out;
    transition: all .2s ease-out;
}

.submit-btn:hover {
    background-color: #2ca893;
    transition: all .2s ease-out;
}
</style>